var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.viewBox,
      "fill": _vm.fill,
      "stroke-width": _vm.stroke_width,
      "stroke-linecap": _vm.stroke_linecap,
      "stroke-linejoin": _vm.stroke_linejoin,
      "stroke": _vm.stroke
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm.name === 'dialer-close-icon' ? [_c('g', {
    attrs: {
      "id": "dialer-close-icon",
      "transform": "translate(-136 1)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12091",
      "data-name": "Group 12091",
      "transform": "translate(136 -1)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12118",
      "data-name": "Path 12118",
      "d": "M35.029,49.752a61.387,61.387,0,0,1-19.073,0A17.661,17.661,0,0,1,1.249,35.029a60.855,60.855,0,0,1,0-19.073A17.652,17.652,0,0,1,15.955,1.249a60.855,60.855,0,0,1,19.073,0A17.661,17.661,0,0,1,49.752,15.955a61.387,61.387,0,0,1,0,19.073A17.67,17.67,0,0,1,35.029,49.752Z",
      "transform": "translate(-0.497 -0.497)",
      "fill": "#ff7d7d"
    }
  }), _c('path', {
    attrs: {
      "id": "close",
      "d": "M11.834,10.137l7.789-7.789A1.3,1.3,0,0,0,17.79.516L10,8.3,2.213.516A1.3,1.3,0,0,0,.38,2.348l7.789,7.789L.38,17.926a1.3,1.3,0,1,0,1.832,1.832L10,11.97l7.789,7.789a1.3,1.3,0,1,0,1.832-1.832Zm0,0",
      "transform": "translate(14.998 14.862)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  })])])] : _vm._e(), _vm.name === 'dialer-call-icon' ? [_c('g', {
    attrs: {
      "id": "call-icon",
      "transform": "translate(-136 1)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12091",
      "data-name": "Group 12091",
      "transform": "translate(136 -1)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12118",
      "data-name": "Path 12118",
      "d": "M35.029,49.752a61.387,61.387,0,0,1-19.073,0A17.661,17.661,0,0,1,1.249,35.029a60.855,60.855,0,0,1,0-19.073A17.652,17.652,0,0,1,15.955,1.249a60.855,60.855,0,0,1,19.073,0A17.661,17.661,0,0,1,49.752,15.955a61.387,61.387,0,0,1,0,19.073A17.67,17.67,0,0,1,35.029,49.752Z",
      "transform": "translate(-0.497 -0.497)",
      "fill": "#3dd66b"
    }
  }), _c('path', {
    attrs: {
      "id": "phone_1_",
      "data-name": "phone (1)",
      "d": "M23.54,18.043v3.226a2.153,2.153,0,0,1-2.349,2.151,21.349,21.349,0,0,1-9.3-3.3,20.989,20.989,0,0,1-6.465-6.452A21.253,21.253,0,0,1,2.121,4.344,2.152,2.152,0,0,1,4.265,2H7.5A2.154,2.154,0,0,1,9.652,3.85a13.784,13.784,0,0,0,.754,3.022A2.147,2.147,0,0,1,9.921,9.14L8.553,10.506a17.222,17.222,0,0,0,6.465,6.452l1.368-1.366a2.158,2.158,0,0,1,2.273-.484,13.857,13.857,0,0,0,3.028.753,2.152,2.152,0,0,1,1.853,2.183Z",
      "transform": "translate(12.174 12.286)",
      "fill": "#fff"
    }
  })])])] : _vm._e(), _vm.name === 'dialer-call-smallIcon' ? [_c('g', {
    attrs: {
      "id": "smallCall-icon",
      "transform": "translate(1 1)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12118",
      "data-name": "Path 12118",
      "d": "M17.072,24.14a29.466,29.466,0,0,1-9.155,0A8.477,8.477,0,0,1,.858,17.072a29.21,29.21,0,0,1,0-9.155A8.473,8.473,0,0,1,7.917.858a29.21,29.21,0,0,1,9.155,0A8.477,8.477,0,0,1,24.14,7.917a29.466,29.466,0,0,1,0,9.155A8.482,8.482,0,0,1,17.072,24.14Z",
      "transform": "translate(-1.498 -1.497)",
      "fill": "#3dd66b"
    }
  }), _c('path', {
    attrs: {
      "id": "phone_1_",
      "data-name": "phone (1)",
      "d": "M15.4,11.95v2a1.335,1.335,0,0,1-1.457,1.334,13.241,13.241,0,0,1-5.767-2.047,13.017,13.017,0,0,1-4.009-4A13.181,13.181,0,0,1,2.117,3.454,1.335,1.335,0,0,1,3.447,2h2A1.336,1.336,0,0,1,6.788,3.147a8.549,8.549,0,0,0,.468,1.874,1.332,1.332,0,0,1-.3,1.407l-.849.847a10.681,10.681,0,0,0,4.009,4l.849-.847a1.338,1.338,0,0,1,1.41-.3,8.594,8.594,0,0,0,1.878.467A1.335,1.335,0,0,1,15.4,11.95Z",
      "transform": "translate(1.888 2)",
      "fill": "#fff"
    }
  })])] : _vm._e(), _vm.name === 'selectPhone-icon' ? [_c('path', {
    attrs: {
      "id": "selectphone-icon",
      "d": "M141.7,14.289h-.05V11.431a1.491,1.491,0,0,0-2.982,0V14.29h-5.4a3.535,3.535,0,0,0-3.535,3.534v18.8a3.535,3.535,0,0,0,3.535,3.535H141.7a3.535,3.535,0,0,0,3.535-3.535v-18.8A3.535,3.535,0,0,0,141.7,14.289Zm-5.232,22.076a.568.568,0,0,1-.567.567h-2.247a.567.567,0,0,1-.566-.567V34.119a.566.566,0,0,1,.566-.566h2.247a.567.567,0,0,1,.567.566Zm0-5.07a.568.568,0,0,1-.567.566h-2.247a.567.567,0,0,1-.566-.566V29.049a.567.567,0,0,1,.566-.567h2.247a.568.568,0,0,1,.567.567Zm5.41,5.07a.568.568,0,0,1-.567.567h-2.246a.568.568,0,0,1-.567-.567V34.119a.567.567,0,0,1,.567-.566h2.246a.567.567,0,0,1,.567.566Zm0-5.07a.568.568,0,0,1-.567.566h-2.246a.568.568,0,0,1-.567-.566V29.049a.568.568,0,0,1,.567-.567h2.246a.568.568,0,0,1,.567.567ZM142.9,24.62a1.136,1.136,0,0,1-1.135,1.135h-8.548a1.136,1.136,0,0,1-1.136-1.135V18.159a1.136,1.136,0,0,1,1.136-1.135h8.548a1.136,1.136,0,0,1,1.135,1.135Z",
      "transform": "translate(-129.734 -9.94)",
      "fill": "#005dff"
    }
  })] : _vm._e(), _vm.name === 'dialer-pin' ? [_c('path', {
    attrs: {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "15",
      "x2": "4.5",
      "y2": "19.5"
    }
  }), _c('line', {
    attrs: {
      "x1": "14.5",
      "y1": "4",
      "x2": "20",
      "y2": "9.5"
    }
  })] : _vm.name === 'dialer-play-circle' ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('polygon', {
    attrs: {
      "points": "10 8 16 12 10 16 10 8"
    }
  })] : _vm.name === 'dialer-play' ? [_c('polygon', {
    attrs: {
      "points": "10 8 16 12 10 16 10 8"
    }
  })] : _vm.name === 'dialer-play-arrowhead' ? [_c('g', {
    attrs: {
      "id": "play-button-arrowhead",
      "transform": "translate(-8.107 0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12125",
      "data-name": "Path 12125",
      "d": "M10.643.353C9.243-.475,8.107.2,8.107,1.866V14.133c0,1.664,1.136,2.341,2.536,1.514L21.056,9.5c1.4-.828,1.4-2.169,0-3Z",
      "transform": "translate(0 0)",
      "fill": "#404040"
    }
  })])] : _vm.name === 'dialer-pause-arrowhead' ? [_c('g', {
    attrs: {
      "id": "pause",
      "transform": "translate(-4.729 0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12201",
      "data-name": "Path 12201",
      "d": "M9.186,13.771A2.229,2.229,0,0,1,6.958,16h0a2.229,2.229,0,0,1-2.229-2.229V2.229A2.229,2.229,0,0,1,6.958,0h0A2.229,2.229,0,0,1,9.186,2.229Z",
      "transform": "translate(0 0)",
      "fill": "#404040"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12202",
      "data-name": "Path 12202",
      "d": "M34.072,13.771A2.229,2.229,0,0,1,31.844,16h0a2.229,2.229,0,0,1-2.229-2.229V2.229A2.229,2.229,0,0,1,31.844,0h0a2.229,2.229,0,0,1,2.229,2.229Z",
      "transform": "translate(-16.343 0)",
      "fill": "#404040"
    }
  })])] : _vm.name === 'dialer-pause-circle' ? [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "15",
      "x2": "10",
      "y2": "9"
    }
  }), _c('line', {
    attrs: {
      "x1": "14",
      "y1": "15",
      "x2": "14",
      "y2": "9"
    }
  })] : _vm.name === 'dialer-pause' ? [_c('path', {
    attrs: {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "6",
      "y": "5",
      "width": "4",
      "height": "14",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "5",
      "width": "4",
      "height": "14",
      "rx": "1"
    }
  })] : _vm.name === 'dialer-send' ? [_c('path', {
    attrs: {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "14",
      "x2": "21",
      "y2": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
    }
  })] : _vm.name === 'dialer-copy-icon' ? [_c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "13",
      "height": "13",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }
  })] : _vm.name === 'dialer-reply-icon' ? [_c('polyline', {
    attrs: {
      "points": "9 14 4 9 9 4"
    }
  }), _c('path', {
    attrs: {
      "d": "M20 20v-7a4 4 0 0 0-4-4H4"
    }
  })] : _vm.name === 'dialer-forward-icon' ? [_c('polyline', {
    attrs: {
      "points": "15 14 20 9 15 4"
    }
  }), _c('path', {
    attrs: {
      "d": "M4 20v-7a4 4 0 0 1 4-4h12"
    }
  })] : _vm.name === 'dialer-delete-icon' ? [_c('path', {
    attrs: {
      "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  }), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "11",
      "x2": "10",
      "y2": "17"
    }
  }), _c('line', {
    attrs: {
      "x1": "14",
      "y1": "11",
      "x2": "14",
      "y2": "17"
    }
  })] : _vm.name === 'dialer-edit-icon' ? [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })] : _vm.name === 'chat-icon' ? [_c('g', {
    attrs: {
      "id": "chat-icon",
      "transform": "translate(12 13)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12117",
      "data-name": "Path 12117",
      "d": "M44.7,63.543a78.576,78.576,0,0,1-24.414,0A22.606,22.606,0,0,1,1.46,44.7a77.9,77.9,0,0,1,0-24.414A22.6,22.6,0,0,1,20.284,1.46a77.9,77.9,0,0,1,24.414,0A22.606,22.606,0,0,1,63.543,20.284a78.575,78.575,0,0,1,0,24.414A22.617,22.617,0,0,1,44.7,63.543Z",
      "transform": "translate(-12.497 -13.497)",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "id": "chat-icon-2",
      "data-name": "chat-icon",
      "transform": "translate(4 1)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_11907",
      "data-name": "Path 11907",
      "d": "M74.7,10c-8.837,0-16,6.822-16,15.237A15.383,15.383,0,0,0,70.6,39.948l13.271,5.6.043-7.867A15.005,15.005,0,0,0,90.7,25.237C90.7,16.822,83.539,10,74.7,10ZM70.5,27.765H66.275V23.547H70.5Zm6.73,0H73.027V23.558h4.206Zm6.73,0h-4.2V23.547h4.2Z",
      "transform": "translate(-58.7 -10)",
      "fill": "#005dff"
    }
  })])])] : _vm.name === 'analytics-icon' ? [_c('g', {
    attrs: {
      "id": "analytics",
      "transform": "translate(16 15.32)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12132",
      "data-name": "Path 12132",
      "d": "M44.7,63.543a78.576,78.576,0,0,1-24.414,0A22.606,22.606,0,0,1,1.46,44.7a77.9,77.9,0,0,1,0-24.414A22.6,22.6,0,0,1,20.284,1.46a77.894,77.894,0,0,1,24.414,0A22.606,22.606,0,0,1,63.543,20.284a78.576,78.576,0,0,1,0,24.414A22.617,22.617,0,0,1,44.7,63.543Z",
      "transform": "translate(-16.498 -15.817)",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "id": "analytics-2",
      "data-name": "analytics",
      "transform": "translate(0 3.68)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_11837",
      "data-name": "Group 11837"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_11895",
      "data-name": "Path 11895",
      "d": "M38.254-424.283a3.028,3.028,0,0,0-2.169,3.589.84.84,0,0,1,.05.382c-.125.106-3.7,2.557-3.775,2.589-.056.025-.225-.05-.388-.156a3.007,3.007,0,0,0-1.444-.481,2.89,2.89,0,0,0-2.338.907l-.4.394-1.538-.525-1.538-.525-.075-.519a2.97,2.97,0,0,0-1.475-2.338,3.416,3.416,0,0,0-1.506-.413,3.035,3.035,0,0,0-2.85,2.12,3.346,3.346,0,0,0-.038,1.645l.081.281-1.931,1.351-1.932,1.344-.306-.206a3,3,0,0,0-4.594,1.763A3.007,3.007,0,0,0,13.7-409.47a3.014,3.014,0,0,0,2.206-3.583l-.081-.332.194-.144c.45-.332,3.576-2.5,3.644-2.52.044-.019.206.062.362.169A2.956,2.956,0,0,0,23.8-416.3l.4-.4,1.538.531,1.544.525.069.525a2.927,2.927,0,0,0,.975,1.963,3,3,0,0,0,4.875-1.363,4.158,4.158,0,0,0,.038-1.757c-.019-.175.081-.25,1.888-1.507l1.9-1.319.3.2a3,3,0,0,0,4.582-1.77A3.013,3.013,0,0,0,38.254-424.283Zm1.206,1.476a1.657,1.657,0,0,1,1.038,1.425,1.575,1.575,0,0,1-1.5,1.5,1.366,1.366,0,0,1-1.031-.469,1.352,1.352,0,0,1,0-2.064A1.379,1.379,0,0,1,39.46-422.808Zm-17.077,3.127a1.586,1.586,0,0,1,.738,1.007,1.514,1.514,0,0,1-.769,1.62,1.4,1.4,0,0,1-.706.144,1.109,1.109,0,0,1-.75-.187,1.509,1.509,0,0,1,.269-2.7A1.658,1.658,0,0,1,22.384-419.681Zm8.726,3.033a1.609,1.609,0,0,1,.481.481,1.126,1.126,0,0,1,.187.788,1.126,1.126,0,0,1-.187.788,1.437,1.437,0,0,1-1.169.694,1.046,1.046,0,0,1-.738-.15,1.487,1.487,0,0,1,.25-2.776A1.67,1.67,0,0,1,31.11-416.648ZM13.458-413.8a1.855,1.855,0,0,1,.963.963,1.37,1.37,0,0,1-.394,1.494,1.352,1.352,0,0,1-2.063,0,1.352,1.352,0,0,1,0-2.063A1.379,1.379,0,0,1,13.458-413.8Z",
      "transform": "translate(-9.996 424.381)",
      "fill": "#005dff"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_11896",
      "data-name": "Path 11896",
      "d": "M807.188-148.262a1.083,1.083,0,0,0-.563.682c-.019.113-.025,3.889-.019,8.4.019,8.173.019,8.2.15,8.373a1.718,1.718,0,0,0,.3.3c.169.125.244.131,2.539.131s2.37-.006,2.539-.131a1.721,1.721,0,0,0,.3-.3c.131-.169.131-.188.131-8.542s0-8.373-.131-8.542a1.721,1.721,0,0,0-.3-.3c-.162-.125-.256-.131-2.464-.144A12.108,12.108,0,0,0,807.188-148.262Z",
      "transform": "translate(-780.595 157.346)",
      "fill": "#005dff"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_11897",
      "data-name": "Path 11897",
      "d": "M276.66-56.676a1.145,1.145,0,0,0-.3.2c-.344.319-.325-.056-.325,7.253v6.778l.144.206a1.637,1.637,0,0,0,.313.338c.169.125.257.131,2.451.15,2.176.019,2.288.012,2.526-.106a1.135,1.135,0,0,0,.388-.363l.15-.237V-56.025l-.15-.237a1.063,1.063,0,0,0-.388-.356c-.225-.119-.369-.125-2.445-.119A22.586,22.586,0,0,0,276.66-56.676Z",
      "transform": "translate(-267.348 68.742)",
      "fill": "#005dff"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_11898",
      "data-name": "Path 11898",
      "d": "M541.686,35.336a1.22,1.22,0,0,0-.375.363c-.131.219-.131.281-.131,5.5s0,5.284.131,5.5a1.22,1.22,0,0,0,.375.363c.244.138.256.138,2.539.125,2.214-.019,2.3-.025,2.47-.15a1.841,1.841,0,0,0,.319-.338l.138-.206V35.9l-.138-.206a1.842,1.842,0,0,0-.319-.338c-.169-.125-.256-.131-2.47-.15C541.942,35.2,541.93,35.2,541.686,35.336Z",
      "transform": "translate(-523.836 -20.2)",
      "fill": "#005dff"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_11899",
      "data-name": "Path 11899",
      "d": "M10.779,127.388a1.082,1.082,0,0,0-.563.682c-.019.113-.031,1.863-.019,3.9.019,3.627.019,3.7.15,3.87a1.718,1.718,0,0,0,.3.3c.169.125.244.131,2.539.131s2.37-.006,2.539-.131a1.718,1.718,0,0,0,.3-.3c.131-.169.131-.231.131-4.039s0-3.871-.131-4.039a1.717,1.717,0,0,0-.3-.3c-.163-.125-.256-.131-2.464-.144A12.1,12.1,0,0,0,10.779,127.388Z",
      "transform": "translate(-10.186 -109.3)",
      "fill": "#005dff"
    }
  })])])])] : _vm.name === 'call-monitoring-icon' ? [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip-path"
    }
  }, [_c('rect', {
    attrs: {
      "x": "6",
      "y": "3",
      "width": "34.053",
      "height": "33.053",
      "fill": "none"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Call-monitoring",
      "transform": "translate(11 41)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12131",
      "data-name": "Path 12131",
      "d": "M44.7,63.543a78.576,78.576,0,0,1-24.414,0A22.606,22.606,0,0,1,1.46,44.7a77.9,77.9,0,0,1,0-24.414A22.6,22.6,0,0,1,20.284,1.46a77.9,77.9,0,0,1,24.414,0A22.606,22.606,0,0,1,63.543,20.284a78.575,78.575,0,0,1,0,24.414A22.617,22.617,0,0,1,44.7,63.543Z",
      "transform": "translate(-11.498 -41.497)",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12070",
      "data-name": "Group 12070",
      "transform": "translate(-2 -29)"
    }
  }, [_c('g', {
    staticStyle: {
      "isolation": "isolate"
    },
    attrs: {
      "id": "Scroll_Group_1",
      "data-name": "Scroll Group 1",
      "transform": "translate(0 0)",
      "clip-path": "url(#clip-path)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12347",
      "data-name": "Group 12347",
      "transform": "translate(0 0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_11909",
      "data-name": "Path 11909",
      "d": "M19.019.048A29.954,29.954,0,0,0,2.586,6.579C.367,8.365.008,8.84,0,9.974s.008,1.151,2.745,3.9c2.669,2.686,2.869,2.836,3.829,2.911a2.521,2.521,0,0,0,1.843-.542A21.579,21.579,0,0,1,12.563,13.3a2.6,2.6,0,0,0,1.418-1.46c.184-.467.2-.617.242-3.2l.042-2.711.9-.183c.492-.092,1.26-.217,1.71-.275a73.39,73.39,0,0,1,7.733-.092,23.609,23.609,0,0,1,3.5.492l.25.067.05,2.753c.05,2.986.067,3.086.559,3.812a2.859,2.859,0,0,0,1.068.8,19.825,19.825,0,0,1,3.787,2.636,2.739,2.739,0,0,0,2.919.751c.425-.134.642-.325,2.978-2.653,2.869-2.853,2.895-2.895,2.9-4.021s-.325-1.577-2.252-3.17A29.775,29.775,0,0,0,24.733.163,43.815,43.815,0,0,0,19.019.048Z",
      "transform": "translate(30.141 42.053) rotate(-135)",
      "fill": "#005dff"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12002",
      "data-name": "Path 12002",
      "d": "M375.978-429.59a1,1,0,0,0-.26.193c-.144.157-.067-.184-1.225,5.229-.44,2.069-.812,3.761-.826,3.761s-.233-1.055-.489-2.348-.494-2.41-.534-2.491a.7.7,0,0,0-1.077-.22c-.144.135-.22.3-.862,1.836l-.557,1.338h-1.261c-1.216,0-1.266,0-1.459.1a.7.7,0,0,0-.036,1.226c.139.085.242.09,1.683.1a14.266,14.266,0,0,0,1.715-.036c.287-.076.413-.247.7-.938a2.683,2.683,0,0,1,.3-.6c.014.023.287,1.347.606,2.954a28.478,28.478,0,0,0,.669,3.048.623.623,0,0,0,.584.314.622.622,0,0,0,.583-.314c.063-.1.368-1.436,1.077-4.744.543-2.536,1-4.583,1.014-4.551s.278,1.014.579,2.186.57,2.19.6,2.267a.873.873,0,0,0,.512.426,8.219,8.219,0,0,0,2.029.049,3.328,3.328,0,0,0,1.212-.153.7.7,0,0,0-.023-1.261c-.144-.067-.229-.072-.835-.031a12.1,12.1,0,0,1-1.7.031c0-.014-.4-1.593-.9-3.515-.53-2.065-.929-3.537-.979-3.6A.717.717,0,0,0,375.978-429.59Z",
      "transform": "translate(-345.363 435.227)",
      "fill": "#005dff"
    }
  })])])])])] : _vm.name === 'meeting-icon' ? [_c('g', {
    attrs: {
      "id": "video_2_",
      "data-name": "video (2)",
      "transform": "translate(14 21)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12210",
      "data-name": "Path 12210",
      "d": "M35.029,49.752a61.387,61.387,0,0,1-19.073,0A17.661,17.661,0,0,1,1.249,35.029a60.855,60.855,0,0,1,0-19.073A17.652,17.652,0,0,1,15.955,1.249a60.855,60.855,0,0,1,19.073,0A17.661,17.661,0,0,1,49.752,15.955a61.387,61.387,0,0,1,0,19.073A17.67,17.67,0,0,1,35.029,49.752Z",
      "transform": "translate(-14.497 -21.498)",
      "fill": "rgba(255,255,255,0.01)"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12647",
      "data-name": "Group 12647",
      "transform": "translate(0 -3)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12131",
      "data-name": "Path 12131",
      "d": "M-1.438,0H12.049a1.6,1.6,0,0,1,1.562,1.642V13.358A1.6,1.6,0,0,1,12.049,15H-1.438A1.6,1.6,0,0,1-3,13.358V1.642A1.6,1.6,0,0,1-1.438,0Z",
      "transform": "translate(3)",
      "fill": "#dce9ff"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_7034",
      "data-name": "Path 7034",
      "d": "M22.9,6,16,10.377v3.339l6.9,3.644Z",
      "transform": "translate(1.099 -4.483)",
      "fill": "#dce9ff"
    }
  })])])] : _vm.name === 'todo-icon' ? [_c('g', {
    attrs: {
      "id": "Group_46767",
      "data-name": "Group 46767",
      "transform": "translate(-16.712 -410.58)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12116",
      "data-name": "Path 12116",
      "d": "M40.411,57.43a70.956,70.956,0,0,1-22.046,0,20.414,20.414,0,0,1-17-17.018,70.341,70.341,0,0,1,0-22.046,20.4,20.4,0,0,1,17-17,70.341,70.341,0,0,1,22.046,0,20.414,20.414,0,0,1,17.018,17,70.956,70.956,0,0,1,0,22.046A20.424,20.424,0,0,1,40.411,57.43Z",
      "transform": "translate(16.216 410.083)",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_46766",
      "data-name": "Group 46766",
      "transform": "translate(-119.797 163.764)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_117568",
      "data-name": "Path 117568",
      "d": "M172.736,284.956a6.2,6.2,0,0,1,2.136.184,3.125,3.125,0,0,1,2.057,2.9q.005,10.472,0,20.944a3.109,3.109,0,0,1-3.091,3.071q-8.429.01-16.858,0a3.112,3.112,0,0,1-3.092-3.07q-.008-10.472,0-20.944A3.121,3.121,0,0,1,157,284.953h1.08l-.009-.01v1.981a1.053,1.053,0,1,0,2.1,0v-1.981l-.009.01h4.2l-.009-.01v1.981a1.053,1.053,0,1,0,2.1,0v-1.981l-.009.01h4.2l-.009-.01v1.981a1.053,1.053,0,1,0,2.1,0q0-.99,0-1.981Zm-7.344,10.421h5.2a1.042,1.042,0,1,0,.011-2.082q-5.2-.008-10.4,0a1.021,1.021,0,0,0-.873.43.968.968,0,0,0-.09,1.073,1.061,1.061,0,0,0,1.017.582Zm.025,5.213h5.1a1.112,1.112,0,0,0,.906-.366.966.966,0,0,0,.171-1.09,1.038,1.038,0,0,0-1.017-.631H160.308a1.112,1.112,0,0,0-.974.428.966.966,0,0,0-.1,1.072,1.055,1.055,0,0,0,1.013.589l5.17,0Zm-2.089,3.125h-3.072a1.045,1.045,0,1,0-.019,2.084q3.072.008,6.145-.005a1.362,1.362,0,0,0,.617-.167.975.975,0,0,0,.461-1.115,1.039,1.039,0,0,0-1.059-.8c-1.025,0-2.049,0-3.073,0Z",
      "transform": "translate(0 -21.647)"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_117569",
      "data-name": "Path 117569",
      "d": "M201.746,263.31c0-.392-.009-.784,0-1.175a1.139,1.139,0,1,1,2.278,0c.007.392,0,.784,0,1.175l.01-.011H201.74Z",
      "transform": "translate(-43.706)"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_117570",
      "data-name": "Path 117570",
      "d": "M273.605,263.31c0-.392-.009-.784,0-1.175a1.139,1.139,0,0,1,2.278,0c.007.392,0,.784,0,1.175l.01-.011H273.6Z",
      "transform": "translate(-109.336)"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_117571",
      "data-name": "Path 117571",
      "d": "M345.465,263.31c0-.392-.009-.784,0-1.175a1.139,1.139,0,1,1,2.278,0c.007.392,0,.784,0,1.175l.01-.011h-2.294Z",
      "transform": "translate(-174.966)"
    }
  })])])] : _vm.name === 'setting-icon' ? [_c('g', {
    attrs: {
      "id": "setting-icon",
      "transform": "translate(16 16)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12133",
      "data-name": "Path 12133",
      "d": "M44.7,63.543a78.576,78.576,0,0,1-24.414,0A22.606,22.606,0,0,1,1.46,44.7a77.9,77.9,0,0,1,0-24.414A22.6,22.6,0,0,1,20.284,1.46a77.894,77.894,0,0,1,24.414,0A22.606,22.606,0,0,1,63.543,20.284a78.576,78.576,0,0,1,0,24.414A22.617,22.617,0,0,1,44.7,63.543Z",
      "transform": "translate(-16.498 -16.497)",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "id": "setting-icon-2",
      "data-name": "setting-icon"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_11919",
      "data-name": "Path 11919",
      "d": "M41.925,28.759,42,23.724l-3.3-.885a12.838,12.838,0,0,0-1.29-3.239l1.8-2.9L35.7,13.079l-2.958,1.708a13.267,13.267,0,0,0-3.2-1.381l-.777-3.331L23.718,10l-.882,3.3A13,13,0,0,0,19.6,14.588l-2.906-1.8L13.073,16.3l1.711,2.955A13.109,13.109,0,0,0,13.4,22.46l-3.331.777L10,28.279l3.3.878a13.072,13.072,0,0,0,1.287,3.249l-1.8,2.9L16.3,38.924l2.958-1.718a12.949,12.949,0,0,0,3.2,1.384l.78,3.334L28.286,42l.878-3.308a12.49,12.49,0,0,0,3.242-1.283l2.9,1.806,3.618-3.51L37.21,32.743a13.055,13.055,0,0,0,1.384-3.2ZM25.866,34.937a8.937,8.937,0,1,1,9.068-8.8A8.942,8.942,0,0,1,25.866,34.937Z",
      "transform": "translate(-10 -10)",
      "fill": "#005dff"
    }
  })])])] : _vm.name === 'avatar-icon' ? [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "avatar-icon"
    }
  }, [_c('path', {
    attrs: {
      "id": "transparent_svg",
      "d": "M35.029,49.752a61.387,61.387,0,0,1-19.073,0A17.661,17.661,0,0,1,1.249,35.029a60.855,60.855,0,0,1,0-19.073A17.652,17.652,0,0,1,15.955,1.249a60.855,60.855,0,0,1,19.073,0A17.661,17.661,0,0,1,49.752,15.955a61.387,61.387,0,0,1,0,19.073A17.67,17.67,0,0,1,35.029,49.752Z",
      "transform": "translate(-0.497 -0.497)",
      "fill": "",
      "opacity": "1"
    }
  })])])] : _vm.name === 'soundSetting-icon' ? [_c('path', {
    attrs: {
      "id": "Path_12128",
      "data-name": "Path 12128",
      "d": "M112.44,336.758a61.422,61.422,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.381,61.381,0,0,1,0-19.075A17.674,17.674,0,0,1,93.361,288.25a61.417,61.417,0,0,1,19.079,0,17.674,17.674,0,0,1,14.719,14.716,61.381,61.381,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z",
      "transform": "translate(-77.905 -287.505)",
      "fill": "#e9f2ff"
    }
  }), _c('g', {
    attrs: {
      "id": "clock_1_",
      "data-name": "clock (1)",
      "transform": "translate(8.502 8.5)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Ellipse_730",
      "data-name": "Ellipse 730",
      "cx": "16.5",
      "cy": "16.5",
      "r": "16.5",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }), _c('g', {
    attrs: {
      "id": "speakers",
      "transform": "translate(8 8)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12590",
      "data-name": "Group 12590"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12203",
      "data-name": "Path 12203",
      "d": "M9.5.8,3.471,5.219H.722A.727.727,0,0,0,0,5.943v6.443a.727.727,0,0,0,.722.724h2.8L9.5,17.524a.723.723,0,0,0,1.156-.543V1.382A.736.736,0,0,0,9.5.8ZM3,11.7H1.409V6.628H3V11.7Zm6.213,3.872L4.477,12.087V6.242L9.208,2.756Z",
      "transform": "translate(0 -0.668)",
      "fill": "#a3a3b1",
      "stroke": "#fff",
      "stroke-width": "0.3"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12204",
      "data-name": "Path 12204",
      "d": "M402.675,102.458a.716.716,0,1,0-1.045.979,5.59,5.59,0,0,1,0,7.541.735.735,0,0,0,.035,1.014.7.7,0,0,0,1.01-.073A6.993,6.993,0,0,0,402.675,102.458Z",
      "transform": "translate(-387.518 -98.712)",
      "fill": "#a3a3b1",
      "stroke": "#fff",
      "stroke-width": "0.3"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12205",
      "data-name": "Path 12205",
      "d": "M341.5,166.958a.73.73,0,0,0-1.01-.035.7.7,0,0,0,0,1.01,2.228,2.228,0,0,1,0,3.033.729.729,0,0,0,.035,1.01.706.706,0,0,0,.975-.035A3.637,3.637,0,0,0,341.5,166.958Z",
      "transform": "translate(-328.47 -160.953)",
      "fill": "#a3a3b1",
      "stroke": "#fff",
      "stroke-width": "0.3"
    }
  })])])])] : _vm.name === 'speedDial-icon' ? [_c('g', {
    staticClass: "speedDial-icon",
    attrs: {
      "id": "speedDial-icon",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12128",
      "data-name": "Path 12128",
      "d": "M112.44,336.758a61.422,61.422,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.381,61.381,0,0,1,0-19.075A17.674,17.674,0,0,1,93.361,288.25a61.417,61.417,0,0,1,19.079,0,17.674,17.674,0,0,1,14.719,14.716,61.381,61.381,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z",
      "transform": "translate(-77.905 -287.505)",
      "fill": "#e9f2ff"
    }
  }), _c('g', {
    staticClass: "speedDial-icon-inner-icon",
    attrs: {
      "id": "clock_1_",
      "data-name": "clock (1)",
      "transform": "translate(8.5 8.5)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Ellipse_730",
      "data-name": "Ellipse 730",
      "cx": "16.5",
      "cy": "16.5",
      "r": "16.5",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_10703",
      "data-name": "Group 10703",
      "transform": "translate(10 11)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Rectangle_2732",
      "data-name": "Rectangle 2732",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-2",
      "data-name": "Rectangle 2732",
      "transform": "translate(5)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-3",
      "data-name": "Rectangle 2732",
      "transform": "translate(10)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-4",
      "data-name": "Rectangle 2732",
      "transform": "translate(0 4)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-5",
      "data-name": "Rectangle 2732",
      "transform": "translate(5 4)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-6",
      "data-name": "Rectangle 2732",
      "transform": "translate(10 4)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-7",
      "data-name": "Rectangle 2732",
      "transform": "translate(0 8)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-8",
      "data-name": "Rectangle 2732",
      "transform": "translate(5 8)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })]), _c('g', {
    attrs: {
      "id": "Rectangle_2732-9",
      "data-name": "Rectangle 2732",
      "transform": "translate(10 8)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-width": "1.5"
    }
  }, [_c('rect', {
    attrs: {
      "width": "3",
      "height": "3",
      "rx": "1.5",
      "stroke": "none"
    }
  }), _c('rect', {
    attrs: {
      "x": "0.75",
      "y": "0.75",
      "width": "1.5",
      "height": "1.5",
      "rx": "0.75",
      "fill": "none"
    }
  })])])])])] : _vm.name === 'addressBook-icon' ? [_c('g', {
    staticClass: "addressBook-icon",
    attrs: {
      "id": "addressBook-icon",
      "transform": "translate(11.34 12)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12130",
      "data-name": "Path 12130",
      "d": "M112.44,336.758a61.422,61.422,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.381,61.381,0,0,1,0-19.075A17.674,17.674,0,0,1,93.361,288.25a61.417,61.417,0,0,1,19.079,0,17.674,17.674,0,0,1,14.719,14.716,61.381,61.381,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z",
      "transform": "translate(-89.245 -299.505)",
      "fill": "#e9f2ff"
    }
  }), _c('g', {
    staticClass: "addressBook-icon-inner-icon",
    attrs: {
      "id": "Group_10691",
      "data-name": "Group 10691",
      "transform": "translate(-1.031 -1.091)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Path_6931",
      "data-name": "Path 6931",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.534,0A14.534,14.534,0,1,1,0,14.534,14.534,14.534,0,0,1,14.534,0Z",
      "stroke": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M 14.53402519226074 -5.7220458984375e-06 C 6.507104873657227 -5.7220458984375e-06 -5.7220458984375e-06 6.507104873657227 -5.7220458984375e-06 14.53402519226074 C -5.7220458984375e-06 22.56094551086426 6.507104873657227 29.06804466247559 14.53402519226074 29.06804466247559 C 22.56094551086426 29.06804466247559 29.06804466247559 22.56094551086426 29.06804466247559 14.53402519226074 C 29.06804466247559 6.507104873657227 22.56094551086426 -5.7220458984375e-06 14.53402519226074 -5.7220458984375e-06 M 14.53402519226074 -2.000005722045898 C 16.76522445678711 -2.000005722045898 18.93074417114258 -1.56257438659668 20.97042465209961 -0.6998538970947266 C 22.93952560424805 0.1330051422119141 24.70753479003906 1.324895858764648 26.22534561157227 2.842704772949219 C 27.74315452575684 4.360515594482422 28.93504524230957 6.128524780273438 29.76789474487305 8.097625732421875 C 30.630615234375 10.13730430603027 31.06804466247559 12.30282592773438 31.06804466247559 14.53402519226074 C 31.06804466247559 16.76522445678711 30.630615234375 18.93074417114258 29.76789474487305 20.97042465209961 C 28.93504524230957 22.93952560424805 27.74315452575684 24.70753479003906 26.22534561157227 26.22534561157227 C 24.70753479003906 27.74315452575684 22.93952560424805 28.93504524230957 20.97042465209961 29.76789474487305 C 18.93074417114258 30.630615234375 16.76522445678711 31.06804466247559 14.53402519226074 31.06804466247559 C 12.30282592773438 31.06804466247559 10.13730430603027 30.630615234375 8.097625732421875 29.76789474487305 C 6.128524780273438 28.93504524230957 4.360515594482422 27.74315452575684 2.842704772949219 26.22534561157227 C 1.324895858764648 24.70753479003906 0.1330051422119141 22.93952560424805 -0.6998538970947266 20.97042465209961 C -1.56257438659668 18.93074417114258 -2.000005722045898 16.76522445678711 -2.000005722045898 14.53402519226074 C -2.000005722045898 12.30282592773438 -1.56257438659668 10.13730430603027 -0.6998538970947266 8.097625732421875 C 0.1330051422119141 6.128524780273438 1.324895858764648 4.360515594482422 2.842704772949219 2.842704772949219 C 4.360515594482422 1.324895858764648 6.128524780273438 0.1330051422119141 8.097625732421875 -0.6998538970947266 C 10.13730430603027 -1.56257438659668 12.30282592773438 -2.000005722045898 14.53402519226074 -2.000005722045898 Z",
      "stroke": "none",
      "fill": "#a3a3b1"
    }
  })])]), _c('g', {
    attrs: {
      "id": "book_2_",
      "data-name": "book (2)",
      "transform": "translate(7.006 5.783)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_7030",
      "data-name": "Path 7030",
      "d": "M4,18.971A1.971,1.971,0,0,1,5.971,17H16.613",
      "transform": "translate(-4 -5.176)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_7031",
      "data-name": "Path 7031",
      "d": "M5.971,2H16.613V17.766H5.971A1.971,1.971,0,0,1,4,15.8V3.971A1.971,1.971,0,0,1,5.971,2Z",
      "transform": "translate(-4 -2)",
      "fill": "none",
      "stroke": "#a3a3b1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  })])])] : _vm.name === 'filter-icon' ? [_c('g', {
    attrs: {
      "id": "Group_12304",
      "data-name": "Group 12304"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_2971",
      "data-name": "Rectangle 2971",
      "width": "19",
      "height": "2",
      "rx": "1",
      "transform": "translate(0 2)",
      "fill": "#005dff"
    }
  }), _c('g', {
    attrs: {
      "id": "Ellipse_925",
      "data-name": "Ellipse 925",
      "transform": "translate(3)",
      "fill": "#fff",
      "stroke": "#005dff",
      "stroke-width": "1.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "3",
      "cy": "3",
      "r": "3",
      "stroke": "none"
    }
  }), _c('circle', {
    attrs: {
      "cx": "3",
      "cy": "3",
      "r": "2.25",
      "fill": "none"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12302",
      "data-name": "Group 12302",
      "transform": "translate(0 12)"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_2973",
      "data-name": "Rectangle 2973",
      "width": "19",
      "height": "2",
      "rx": "1",
      "transform": "translate(0 2)",
      "fill": "#005dff"
    }
  }), _c('g', {
    attrs: {
      "id": "Ellipse_927",
      "data-name": "Ellipse 927",
      "transform": "translate(3)",
      "fill": "#fff",
      "stroke": "#005dff",
      "stroke-width": "1.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "3",
      "cy": "3",
      "r": "3",
      "stroke": "none"
    }
  }), _c('circle', {
    attrs: {
      "cx": "3",
      "cy": "3",
      "r": "2.25",
      "fill": "none"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12303",
      "data-name": "Group 12303",
      "transform": "translate(0 6)"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_2972",
      "data-name": "Rectangle 2972",
      "width": "19",
      "height": "2",
      "rx": "1",
      "transform": "translate(0 2)",
      "fill": "#005dff"
    }
  }), _c('g', {
    attrs: {
      "id": "Ellipse_926",
      "data-name": "Ellipse 926",
      "transform": "translate(11)",
      "fill": "#fff",
      "stroke": "#005dff",
      "stroke-width": "1.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "3",
      "cy": "3",
      "r": "3",
      "stroke": "none"
    }
  }), _c('circle', {
    attrs: {
      "cx": "3",
      "cy": "3",
      "r": "2.25",
      "fill": "none"
    }
  })])])] : _vm.name === 'dialedCall-icon' ? [_c('g', {
    attrs: {
      "id": "dialedCall-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#005dff"
    }
  }), _c('g', {
    attrs: {
      "id": "phone-incoming_1_",
      "data-name": "phone-incoming (1)",
      "transform": "translate(6.888 7.725)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12328",
      "data-name": "Group 12328",
      "transform": "translate(12.75 1)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6946",
      "data-name": "Path 6946",
      "d": "M4.6,4.6V0H0",
      "transform": "translate(0.766 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_2",
      "data-name": "Line 2",
      "y1": "5.362",
      "x2": "5.362",
      "transform": "translate(0 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })]), _c('path', {
    attrs: {
      "id": "Path_6947",
      "data-name": "Path 6947",
      "d": "M17.346,13.406V15.7a1.531,1.531,0,0,1-1.67,1.529,15.179,15.179,0,0,1-6.611-2.347,14.922,14.922,0,0,1-4.6-4.587A15.109,15.109,0,0,1,2.118,3.666,1.53,1.53,0,0,1,3.642,2h2.3A1.531,1.531,0,0,1,7.472,3.315a9.8,9.8,0,0,0,.536,2.148,1.527,1.527,0,0,1-.345,1.613l-.973.971a12.244,12.244,0,0,0,4.6,4.587l.973-.971a1.534,1.534,0,0,1,1.616-.344,9.852,9.852,0,0,0,2.152.535A1.53,1.53,0,0,1,17.346,13.406Z",
      "transform": "translate(0 -0.234)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])] : _vm.name === 'dialedVideo-icon' ? [_c('g', {
    attrs: {
      "id": "dialedVideo-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#005dff"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12332",
      "data-name": "Group 12332"
    }
  }, [_c('path', {
    attrs: {
      "id": "video-camera",
      "d": "M20.452,1.161a.438.438,0,0,0-.433-.008L15.277,3.743V2.189A2.192,2.192,0,0,0,13.088,0H2.19A2.192,2.192,0,0,0,0,2.189v8.644A2.192,2.192,0,0,0,2.19,13.022h10.9a2.192,2.192,0,0,0,2.189-2.189V9.308L20.019,11.9a.438.438,0,0,0,.648-.384V1.538a.438.438,0,0,0-.214-.376ZM14.4,10.833a1.315,1.315,0,0,1-1.314,1.314H2.19A1.315,1.315,0,0,1,.876,10.833V2.189A1.315,1.315,0,0,1,2.19.876h10.9A1.315,1.315,0,0,1,14.4,2.189Zm5.39-.058L15.277,8.31V4.74l4.514-2.464Zm0,0",
      "transform": "translate(7.167 10.202)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12328",
      "data-name": "Group 12328",
      "transform": "translate(11.639 14.046)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6946",
      "data-name": "Path 6946",
      "d": "M4.6,4.6V0H0",
      "transform": "translate(0.766 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_2",
      "data-name": "Line 2",
      "y1": "5.362",
      "x2": "5.362",
      "transform": "translate(0 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])])] : _vm.name === 'receivedCall-icon' ? [_c('g', {
    attrs: {
      "id": "recievedCall-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#3dd66b"
    }
  }), _c('g', {
    attrs: {
      "id": "phone-incoming_1_",
      "data-name": "phone-incoming (1)",
      "transform": "translate(6.888 7.709)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6946",
      "data-name": "Path 6946",
      "d": "M16,2V6.6h4.6",
      "transform": "translate(-3.248 -0.234)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_2",
      "data-name": "Line 2",
      "x1": "5.363",
      "y2": "5.363",
      "transform": "translate(12.752 1)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_6947",
      "data-name": "Path 6947",
      "d": "M17.349,13.405V15.7a1.531,1.531,0,0,1-1.67,1.529,15.183,15.183,0,0,1-6.612-2.347,14.923,14.923,0,0,1-4.6-4.587A15.107,15.107,0,0,1,2.118,3.666,1.53,1.53,0,0,1,3.643,2h2.3A1.531,1.531,0,0,1,7.473,3.315,9.8,9.8,0,0,0,8.01,5.463a1.526,1.526,0,0,1-.345,1.613l-.973.971a12.245,12.245,0,0,0,4.6,4.587l.973-.971a1.535,1.535,0,0,1,1.617-.344,9.855,9.855,0,0,0,2.153.535A1.53,1.53,0,0,1,17.349,13.405Z",
      "transform": "translate(0 -0.234)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])] : _vm.name === 'receivedVideo-icon' ? [_c('g', {
    attrs: {
      "id": "recievedVideo-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#5791ff"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12333",
      "data-name": "Group 12333"
    }
  }, [_c('path', {
    attrs: {
      "id": "video-camera",
      "d": "M20.452,1.161a.438.438,0,0,0-.433-.008L15.277,3.743V2.189A2.192,2.192,0,0,0,13.088,0H2.19A2.192,2.192,0,0,0,0,2.189v8.644A2.192,2.192,0,0,0,2.19,13.022h10.9a2.192,2.192,0,0,0,2.189-2.189V9.308L20.019,11.9a.438.438,0,0,0,.648-.384V1.538a.438.438,0,0,0-.214-.376ZM14.4,10.833a1.315,1.315,0,0,1-1.314,1.314H2.19A1.315,1.315,0,0,1,.876,10.833V2.189A1.315,1.315,0,0,1,2.19.876h10.9A1.315,1.315,0,0,1,14.4,2.189Zm5.39-.058L15.277,8.31V4.74l4.514-2.464Zm0,0",
      "transform": "translate(7.167 10.202)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12328",
      "data-name": "Group 12328",
      "transform": "translate(11.639 14.046)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6946",
      "data-name": "Path 6946",
      "d": "M0,0V4.6H4.6",
      "transform": "translate(0 0.766)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_2",
      "data-name": "Line 2",
      "x1": "5.362",
      "y2": "5.362",
      "transform": "translate(0 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])])] : _vm.name === 'sendMessage-icon' ? [_c('g', {
    attrs: {
      "id": "messageSend-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#f5bc00"
    }
  }), _c('g', {
    attrs: {
      "id": "chat",
      "transform": "translate(7 5.727)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12312",
      "data-name": "Group 12312",
      "transform": "translate(0)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12311",
      "data-name": "Group 12311",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12120",
      "data-name": "Path 12120",
      "d": "M13.895,0c-.006.006-.017.006-.034.006A10.472,10.472,0,0,0,5.648,17L4.121,20.549a.569.569,0,0,0,.3.749.581.581,0,0,0,.326.04l5.6-.984a10.09,10.09,0,0,0,3.489.606A10.48,10.48,0,0,0,13.895,0Zm-.057,19.823a9.18,9.18,0,0,1-3.231-.589.548.548,0,0,0-.3-.029l-4.713.824,1.247-2.9a.575.575,0,0,0-.092-.6,9.143,9.143,0,0,1-1.59-2.642,9.338,9.338,0,1,1,18.032-3.454v.034A9.363,9.363,0,0,1,13.838,19.823Z",
      "transform": "translate(-3.366)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "0.8"
    }
  })])])]), _c('g', {
    attrs: {
      "id": "Group_12329",
      "data-name": "Group 12329",
      "transform": "translate(14.359 13.278)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6946",
      "data-name": "Path 6946",
      "d": "M5.352,5.352V0H0",
      "transform": "translate(0.892 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_2",
      "data-name": "Line 2",
      "y1": "6.244",
      "x2": "6.244",
      "transform": "translate(0 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])] : _vm.name === 'receivedMessage-icon' ? [_c('g', {
    attrs: {
      "id": "messageRecieved-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#00dcf5"
    }
  }), _c('g', {
    attrs: {
      "id": "chat",
      "transform": "translate(7 5.727)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12312",
      "data-name": "Group 12312",
      "transform": "translate(0)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12311",
      "data-name": "Group 12311",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12120",
      "data-name": "Path 12120",
      "d": "M13.895,0c-.006.006-.017.006-.034.006A10.472,10.472,0,0,0,5.648,17L4.121,20.549a.569.569,0,0,0,.3.749.581.581,0,0,0,.326.04l5.6-.984a10.09,10.09,0,0,0,3.489.606A10.48,10.48,0,0,0,13.895,0Zm-.057,19.823a9.18,9.18,0,0,1-3.231-.589.548.548,0,0,0-.3-.029l-4.713.824,1.247-2.9a.575.575,0,0,0-.092-.6,9.143,9.143,0,0,1-1.59-2.642,9.338,9.338,0,1,1,18.032-3.454v.034A9.363,9.363,0,0,1,13.838,19.823Z",
      "transform": "translate(-3.366)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "0.8"
    }
  })])])]), _c('g', {
    attrs: {
      "id": "Group_12329",
      "data-name": "Group 12329",
      "transform": "translate(14.359 13.278)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6946",
      "data-name": "Path 6946",
      "d": "M0,0V5.352H5.352",
      "transform": "translate(0 0.892)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_2",
      "data-name": "Line 2",
      "x1": "6.244",
      "y2": "6.244",
      "transform": "translate(0 0)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])] : _vm.name === 'missedCall-icon' ? [_c('g', {
    attrs: {
      "id": "missedCall-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#ff7d7d"
    }
  }), _c('g', {
    attrs: {
      "id": "phone-off",
      "transform": "translate(9 8.727)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_6943",
      "data-name": "Path 6943",
      "d": "M9.006,11.094a12.874,12.874,0,0,0,2.744,2.091l1.022-1.021a1.61,1.61,0,0,1,1.7-.362,10.338,10.338,0,0,0,2.261.563,1.609,1.609,0,0,1,1.384,1.608v2.412a1.609,1.609,0,0,1-1.754,1.608,15.932,15.932,0,0,1-6.944-2.469,15.625,15.625,0,0,1-2.68-2.147M4.589,10.692a15.906,15.906,0,0,1-2.47-6.939A1.609,1.609,0,0,1,3.72,2H6.134A1.609,1.609,0,0,1,7.743,3.383a10.319,10.319,0,0,0,.563,2.26,1.607,1.607,0,0,1-.362,1.7L6.922,8.36",
      "transform": "translate(-2.112 -2)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_1",
      "data-name": "Line 1",
      "x1": "13.547",
      "y2": "13.535",
      "transform": "translate(0.279 2.176)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])] : _vm.name === 'missedVideo-icon' ? [_c('g', {
    attrs: {
      "id": "MissedVideo-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#ff7d7d"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12334",
      "data-name": "Group 12334",
      "transform": "translate(-0.498 0.014)"
    }
  }, [_c('path', {
    attrs: {
      "id": "video-camera",
      "d": "M20.452,1.161a.438.438,0,0,0-.433-.008L15.277,3.743V2.189A2.192,2.192,0,0,0,13.088,0H2.19A2.192,2.192,0,0,0,0,2.189v8.644A2.192,2.192,0,0,0,2.19,13.022h10.9a2.192,2.192,0,0,0,2.189-2.189V9.308L20.019,11.9a.438.438,0,0,0,.648-.384V1.538a.438.438,0,0,0-.214-.376ZM14.4,10.833a1.315,1.315,0,0,1-1.314,1.314H2.19A1.315,1.315,0,0,1,.876,10.833V2.189A1.315,1.315,0,0,1,2.19.876h10.9A1.315,1.315,0,0,1,14.4,2.189Zm5.39-.058L15.277,8.31V4.74l4.514-2.464Zm0,0",
      "transform": "translate(7.167 10.202)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "1"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12335",
      "data-name": "Group 12335"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_2984",
      "data-name": "Rectangle 2984",
      "width": "10",
      "height": "1.5",
      "rx": "0.75",
      "transform": "translate(10.434 19.469) rotate(-45)",
      "fill": "#fff"
    }
  }), _c('rect', {
    attrs: {
      "id": "Rectangle_2985",
      "data-name": "Rectangle 2985",
      "width": "10",
      "height": "1.5",
      "rx": "0.75",
      "transform": "translate(17.505 20.529) rotate(-135)",
      "fill": "#fff"
    }
  })])])])] : _vm.name === 'voiceMessage-icon' ? [_c('g', {
    attrs: {
      "id": "ledCall-icon",
      "transform": "translate(0 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#19c8ff"
    }
  }), _c('g', {
    attrs: {
      "id": "voicemail_2_",
      "data-name": "voicemail (2)",
      "transform": "translate(6 5.545)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Ellipse_686",
      "data-name": "Ellipse 686",
      "cx": "4",
      "cy": "4",
      "r": "4",
      "transform": "translate(1 7.182)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('circle', {
    attrs: {
      "id": "Ellipse_687",
      "data-name": "Ellipse 687",
      "cx": "4",
      "cy": "4",
      "r": "4",
      "transform": "translate(13 7.182)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('line', {
    attrs: {
      "id": "Line_3",
      "data-name": "Line 3",
      "x2": "11.818",
      "transform": "translate(5.091 15.182)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })])])] : _vm.name === 'audioMessage-icon' ? [_c('g', {
    attrs: {
      "id": "Group_10707",
      "data-name": "Group 10707",
      "transform": "translate(-0.001 0.273)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.77)",
      "fill": "#ff7d7d"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12338",
      "data-name": "Group 12338",
      "transform": "translate(0.001 0.316)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12124",
      "data-name": "Path 12124",
      "d": "M17.349,13.405V15.7a1.531,1.531,0,0,1-1.67,1.529,15.183,15.183,0,0,1-6.612-2.347,14.923,14.923,0,0,1-4.6-4.587A15.107,15.107,0,0,1,2.118,3.666,1.53,1.53,0,0,1,3.643,2h2.3A1.531,1.531,0,0,1,7.473,3.315,9.8,9.8,0,0,0,8.01,5.463a1.526,1.526,0,0,1-.345,1.613l-.973.971a12.245,12.245,0,0,0,4.6,4.587l.973-.971a1.535,1.535,0,0,1,1.617-.344,9.855,9.855,0,0,0,2.153.535A1.53,1.53,0,0,1,17.349,13.405Z",
      "transform": "translate(6.888 7.475)",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_12337",
      "data-name": "Group 12337",
      "transform": "translate(6.501 -4.986)"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_2984",
      "data-name": "Rectangle 2984",
      "width": "10",
      "height": "1.5",
      "rx": "0.75",
      "transform": "translate(10.434 19.469) rotate(-45)",
      "fill": "#fff"
    }
  }), _c('rect', {
    attrs: {
      "id": "Rectangle_2985",
      "data-name": "Rectangle 2985",
      "width": "10",
      "height": "1.5",
      "rx": "0.75",
      "transform": "translate(17.505 20.529) rotate(-135)",
      "fill": "#fff"
    }
  })])])])] : _vm.name === 'dialer-tick' ? [_c('g', {
    attrs: {
      "id": "tick",
      "transform": "translate(0.25 -67.705)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12602",
      "data-name": "Group 12602",
      "transform": "translate(0 67.997)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12206",
      "data-name": "Path 12206",
      "d": "M9.853,68.137a.518.518,0,0,0-.707,0l-5.99,5.71-2.3-2.195a.518.518,0,0,0-.707,0,.461.461,0,0,0,0,.674L2.8,74.858a.518.518,0,0,0,.707,0l6.344-6.047A.461.461,0,0,0,9.853,68.137Z",
      "transform": "translate(0 -67.998)",
      "fill": "#777",
      "stroke": "#777",
      "stroke-width": "0.5"
    }
  })])])] : _vm.name === 'dialer-outlineCall-icon' ? [_c('path', {
    attrs: {
      "id": "dialer-outlineCall-icon",
      "d": "M19.111,14.728v2.559a1.708,1.708,0,0,1-1.863,1.706,16.937,16.937,0,0,1-7.376-2.619,16.651,16.651,0,0,1-5.128-5.118,16.86,16.86,0,0,1-2.624-7.4A1.707,1.707,0,0,1,3.82,2H6.384A1.708,1.708,0,0,1,8.094,3.467a10.935,10.935,0,0,0,.6,2.4,1.7,1.7,0,0,1-.385,1.8L7.222,8.748a13.662,13.662,0,0,0,5.128,5.118l1.086-1.083a1.712,1.712,0,0,1,1.8-.384,10.993,10.993,0,0,0,2.4.6,1.707,1.707,0,0,1,1.47,1.732Z",
      "transform": "translate(-1.211 -1.1)",
      "fill": "#fff",
      "stroke": "#707070",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.8"
    }
  })] : _vm.name === 'dialer-outlinePlay-icon' ? [_c('path', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "dialer-outlinePlay-icon",
      "d": "M10.643.353C9.243-.475,8.107.2,8.107,1.866V14.133c0,1.664,1.136,2.341,2.536,1.514L21.056,9.5c1.4-.828,1.4-2.169,0-3Z",
      "transform": "translate(-7.107 1.018)",
      "fill": "#fff",
      "stroke": "#707070",
      "stroke-width": "2"
    }
  })] : _vm.name === 'dialer-outlineCall-icon2' ? [_c('path', {
    attrs: {
      "id": "dialer-outlineCall-icon",
      "d": "M17.111,13.23v2.258a1.507,1.507,0,0,1-1.644,1.505,14.945,14.945,0,0,1-6.509-2.311,14.692,14.692,0,0,1-4.525-4.516A14.877,14.877,0,0,1,2.118,3.641,1.507,1.507,0,0,1,3.619,2H5.881A1.507,1.507,0,0,1,7.39,3.295,9.649,9.649,0,0,0,7.918,5.41,1.5,1.5,0,0,1,7.578,7l-.958.956a12.055,12.055,0,0,0,4.525,4.516l.958-.956a1.511,1.511,0,0,1,1.591-.339,9.7,9.7,0,0,0,2.119.527A1.506,1.506,0,0,1,17.111,13.23Z",
      "transform": "translate(-1.361 -1.25)",
      "fill": "none",
      "stroke": "#4a4a4a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }
  })] : _vm.name === 'dialer-outlineChat-icon' ? [_c('g', {
    attrs: {
      "id": "dialer-outlineChat-icon",
      "transform": "translate(0.25 0.25)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12312",
      "data-name": "Group 12312",
      "transform": "translate(0 0)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12311",
      "data-name": "Group 12311"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12120",
      "data-name": "Path 12120",
      "d": "M11.4,0s-.013,0-.026,0A7.948,7.948,0,0,0,3.366,7.871a7.725,7.725,0,0,0,1.742,4.874L3.942,15.4a.424.424,0,0,0,.227.562.451.451,0,0,0,.249.03l4.274-.737a7.829,7.829,0,0,0,2.663.454,7.948,7.948,0,0,0,8.011-7.866A7.9,7.9,0,0,0,11.4,0ZM11.36,14.858a7.122,7.122,0,0,1-2.467-.442.426.426,0,0,0-.231-.021l-3.6.617.952-2.173a.425.425,0,0,0-.07-.45,6.864,6.864,0,0,1-1.7-4.523A7.083,7.083,0,0,1,11.381.857,7.035,7.035,0,0,1,18.5,7.819v.026A7.083,7.083,0,0,1,11.36,14.858Z",
      "transform": "translate(-3.366)",
      "fill": "#4a4a4a",
      "stroke": "#4a4a4a",
      "stroke-width": "0.5"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12314",
      "data-name": "Group 12314",
      "transform": "translate(4.859 5.301)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12313",
      "data-name": "Group 12313"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12121",
      "data-name": "Path 12121",
      "d": "M117.46,146.7H115.1a.437.437,0,1,0,0,.873h2.357a.437.437,0,1,0,0-.873Z",
      "transform": "translate(-114.666 -146.7)",
      "fill": "#4a4a4a",
      "stroke": "#4a4a4a",
      "stroke-width": "0.5"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12316",
      "data-name": "Group 12316",
      "transform": "translate(4.859 8.424)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12315",
      "data-name": "Group 12315"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12122",
      "data-name": "Path 12122",
      "d": "M120.516,196.7H115.1a.437.437,0,0,0,0,.873h5.413a.437.437,0,0,0,0-.873Z",
      "transform": "translate(-114.666 -196.7)",
      "fill": "#4a4a4a",
      "stroke": "#4a4a4a",
      "stroke-width": "0.5"
    }
  })])])])] : _vm.name === 'dialer-outlineVideo-icon' ? [_c('path', {
    attrs: {
      "id": "dialer-outlineVideo-icon",
      "d": "M19.793,1.159a.413.413,0,0,0-.419-.008L14.785,3.736V2.185A2.155,2.155,0,0,0,12.666,0H2.119A2.155,2.155,0,0,0,0,2.185v8.629A2.155,2.155,0,0,0,2.119,13H12.666a2.155,2.155,0,0,0,2.119-2.185V9.292l4.589,2.585a.413.413,0,0,0,.419-.008A.44.44,0,0,0,20,11.493V1.535a.44.44,0,0,0-.208-.376Zm-5.856,9.655a1.293,1.293,0,0,1-1.271,1.311H2.119A1.293,1.293,0,0,1,.848,10.815V2.185A1.293,1.293,0,0,1,2.119.874H12.666a1.293,1.293,0,0,1,1.271,1.311Zm5.216-.058L14.785,8.3V4.732l4.368-2.46Zm0,0",
      "transform": "translate(0.299 0.3)",
      "fill": "#4a4a4a",
      "stroke": "#4a4a4a",
      "stroke-width": "0.6"
    }
  })] : _vm.name === 'leftLongArrow-icon' ? [_c('g', {
    attrs: {
      "id": "Left-longArrow",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12329",
      "data-name": "Path 12329",
      "d": "M.378,139.087h0l6.736-6.71A1.29,1.29,0,0,1,8.934,134.2l-4.522,4.5h24.3a1.29,1.29,0,0,1,0,2.581H4.411l4.522,4.5a1.29,1.29,0,0,1-1.819,1.829l-6.736-6.71h0A1.292,1.292,0,0,1,.378,139.087Z",
      "transform": "translate(0 -132)",
      "fill": "#000000"
    }
  })])] : _vm.name === 'dialer-plus-icon' ? [_c('path', {
    attrs: {
      "id": "plus",
      "d": "M11.4,5.4H6.6V.6A.6.6,0,0,0,5.4.6V5.4H.6a.6.6,0,0,0,0,1.2H5.4v4.8a.6.6,0,1,0,1.2,0V6.6h4.8a.6.6,0,1,0,0-1.2Zm0,0",
      "transform": "translate(0)",
      "fill": "#565656"
    }
  })] : _vm.name === 'dialer-largePlus-icon' ? [_c('path', {
    attrs: {
      "id": "plus",
      "d": "M15.2,7.2H8.8V.8A.8.8,0,0,0,7.2.8V7.2H.8a.8.8,0,0,0,0,1.6H7.2v6.4a.8.8,0,1,0,1.6,0V8.8h6.4a.8.8,0,1,0,0-1.6Zm0,0",
      "transform": "translate(0)",
      "fill": "#fff"
    }
  })] : _vm.name === 'dialer-arrow-ios-back-outline-icon' ? [_c('path', {
    attrs: {
      "id": "arrow-ios-back-outline",
      "d": "M13.83,19a1,1,0,0,1-.78-.37l-4.83-6a1,1,0,0,1,0-1.27l5-6a1,1,0,0,1,1.54,1.28L10.29,12l4.32,5.36A1,1,0,0,1,13.83,19Z",
      "transform": "translate(-7.993 -4.999)",
      "fill": "#707070"
    }
  })] : _vm.name === 'dialer-block-icon' ? [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.497)",
      "fill": "#ff7d7d"
    }
  }), _c('path', {
    attrs: {
      "id": "block",
      "d": "M10,.167A9.625,9.625,0,0,1,17.073,3.1,9.643,9.643,0,0,1,20,10.167a9.643,9.643,0,0,1-2.927,7.066A9.625,9.625,0,0,1,10,20.167a9.625,9.625,0,0,1-7.073-2.934A9.643,9.643,0,0,1,0,10.167,9.643,9.643,0,0,1,2.927,3.1,9.625,9.625,0,0,1,10,.167Zm-7.986,10A7.792,7.792,0,0,0,3.7,15.1L14.9,3.829a7.753,7.753,0,0,0-4.918-1.69A7.657,7.657,0,0,0,4.356,4.486,7.747,7.747,0,0,0,2.014,10.167ZM9.976,18.2a7.711,7.711,0,0,0,5.667-2.348,7.747,7.747,0,0,0,2.342-5.681A7.792,7.792,0,0,0,16.3,5.238L5.106,16.505A7.687,7.687,0,0,0,9.977,18.2Z",
      "transform": "translate(7 6.833)",
      "fill": "#fff"
    }
  })] : _vm.name === 'dialer-sms-icon' ? [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.497 -0.497)",
      "fill": "#00dcf5"
    }
  }), _c('g', {
    attrs: {
      "id": "chat-left",
      "transform": "translate(7 8)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12331",
      "data-name": "Path 12331",
      "d": "M17.5,1.177H2.5A1.215,1.215,0,0,0,1.25,2.354V15.992l2.5-2.354a2.581,2.581,0,0,1,1.767-.69H17.5a1.215,1.215,0,0,0,1.25-1.177V2.354A1.215,1.215,0,0,0,17.5,1.177ZM2.5,0A2.43,2.43,0,0,0,0,2.354V17.412a.589.589,0,0,0,.386.543.654.654,0,0,0,.681-.128l3.566-3.358a1.29,1.29,0,0,1,.884-.345H17.5A2.43,2.43,0,0,0,20,11.771V2.354A2.43,2.43,0,0,0,17.5,0Z",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "0.8",
      "fill-rule": "evenodd"
    }
  })])] : _vm.name === 'dialer-callinfo-call-icon' ? [_c('path', {
    attrs: {
      "id": "Path_12119",
      "data-name": "Path 12119",
      "d": "M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z",
      "transform": "translate(-0.498 -0.497)",
      "fill": "#005dff"
    }
  }), _c('path', {
    attrs: {
      "id": "phone",
      "d": "M18.167,20.25h-.118C4.45,19.467,2.519,7.989,2.249,4.487A2.077,2.077,0,0,1,4.16,2.25H7.973a1.384,1.384,0,0,1,1.287.872l1.052,2.589a1.385,1.385,0,0,1-.3,1.5L8.534,8.695a6.485,6.485,0,0,0,5.246,5.262l1.5-1.488a1.384,1.384,0,0,1,1.5-.283l2.609,1.046a1.385,1.385,0,0,1,.851,1.287v3.655A2.077,2.077,0,0,1,18.167,20.25ZM4.326,3.635a.692.692,0,0,0-.692.692v.055c.318,4.1,2.36,13.791,14.492,14.483a.692.692,0,0,0,.734-.651v-3.7l-2.609-1.046-1.986,1.974-.332-.042c-6.021-.755-6.837-6.777-6.837-6.84l-.042-.332L9.018,6.245,7.98,3.635Z",
      "transform": "translate(5.757 5.75)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "0.5"
    }
  })] : _vm.name === 'dialer-addUser-icon' ? [_c('g', {
    attrs: {
      "id": "user",
      "transform": "translate(0.156 0.15)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12533",
      "data-name": "Group 12533"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12152",
      "data-name": "Path 12152",
      "d": "M17.95,15.42a.7.7,0,0,0-1.376.287.734.734,0,0,1-.149.616.714.714,0,0,1-.562.267H2.134a.714.714,0,0,1-.562-.267.734.734,0,0,1-.149-.616,7.766,7.766,0,0,1,7.389-6.15q.093,0,.186,0t.187,0a7.733,7.733,0,0,1,6.245,3.432.7.7,0,1,0,1.168-.783,9.143,9.143,0,0,0-4.738-3.6,4.78,4.78,0,1,0-5.722,0A9.143,9.143,0,0,0,.046,15.42,2.136,2.136,0,0,0,2.134,18H15.862A2.136,2.136,0,0,0,17.95,15.42ZM5.624,4.78A3.374,3.374,0,1,1,9.169,8.15L9,8.148l-.17,0A3.378,3.378,0,0,1,5.624,4.78Z",
      "transform": "translate(0)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "0.3"
    }
  })]), _c('path', {
    attrs: {
      "id": "plus",
      "d": "M7.6,3.6H4.4V.4a.4.4,0,0,0-.8,0V3.6H.4a.4.4,0,0,0,0,.8H3.6V7.6a.4.4,0,1,0,.8,0V4.4H7.6a.4.4,0,1,0,0-.8Zm0,0",
      "transform": "translate(14.999 2.997)",
      "fill": "#fff",
      "stroke": "#fff",
      "stroke-width": "0.5"
    }
  })])] : _vm.name === 'dialer-downArrow-icon' ? [_c('path', {
    attrs: {
      "id": "dialer-down-arrow",
      "d": "M7,105.142a.976.976,0,0,1-.693-.288L.288,98.818a.982.982,0,0,1,1.386-1.39L7,102.769l5.326-5.34a.982.982,0,1,1,1.386,1.39l-6.02,6.035A.976.976,0,0,1,7,105.142Z",
      "transform": "translate(-0.001 -97.141)",
      "fill": "#565656"
    }
  })] : _vm.name === 'dialer-numberPad-icon' ? [_c('g', {
    attrs: {
      "id": "Group_12543",
      "data-name": "Group 12543"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12542",
      "data-name": "Group 12542"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12153",
      "data-name": "Path 12153",
      "d": "M2.25,0A2.25,2.25,0,1,0,4.5,2.25,2.253,2.253,0,0,0,2.25,0Z",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12154",
      "data-name": "Path 12154",
      "d": "M2.25,192a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,2.25,192Z",
      "transform": "translate(0 -185.25)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12155",
      "data-name": "Path 12155",
      "d": "M2.25,384a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,2.25,384Z",
      "transform": "translate(0 -370.5)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12156",
      "data-name": "Path 12156",
      "d": "M194.25,0a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,194.25,0Z",
      "transform": "translate(-185.25)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12157",
      "data-name": "Path 12157",
      "d": "M194.25,192a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,194.25,192Z",
      "transform": "translate(-185.25 -185.25)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12158",
      "data-name": "Path 12158",
      "d": "M194.25,384a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,194.25,384Z",
      "transform": "translate(-185.25 -370.5)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12159",
      "data-name": "Path 12159",
      "d": "M386.25,4.5A2.25,2.25,0,1,0,384,2.25,2.253,2.253,0,0,0,386.25,4.5Z",
      "transform": "translate(-370.5)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12160",
      "data-name": "Path 12160",
      "d": "M386.25,192a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,386.25,192Z",
      "transform": "translate(-370.5 -185.25)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12161",
      "data-name": "Path 12161",
      "d": "M386.25,384a2.25,2.25,0,1,0,2.25,2.25A2.253,2.253,0,0,0,386.25,384Z",
      "transform": "translate(-370.5 -370.5)",
      "fill": "#575757"
    }
  })])])] : _vm.name === 'dialer-smartPhone-icon' ? [_c('g', {
    attrs: {
      "id": "smartphone",
      "transform": "translate(-113.692)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12544",
      "data-name": "Group 12544",
      "transform": "translate(113.692)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12162",
      "data-name": "Path 12162",
      "d": "M121.788,0h-6.159a1.924,1.924,0,0,0-1.937,1.877V16.129A1.906,1.906,0,0,0,115.61,18L121.779,18a1.893,1.893,0,0,0,1.9-1.875l.009-14.247A1.889,1.889,0,0,0,121.788,0Zm-3.969,1.125h1.787a.281.281,0,1,1,0,.563h-1.787a.281.281,0,1,1,0-.563Zm-1.074.09a.3.3,0,0,1,.4,0,.278.278,0,0,1,0,.4.29.29,0,0,1-.2.083.294.294,0,0,1-.2-.083.281.281,0,0,1,0-.4Zm1.91,16.232a.842.842,0,1,1,.852-.842A.848.848,0,0,1,118.655,17.447Zm4.153-2.256h-8.119V2.673h8.119Z",
      "transform": "translate(-113.692)",
      "fill": "#575757"
    }
  })])])] : _vm.name === 'dialer-devices-icon' ? [_c('g', {
    attrs: {
      "id": "monitor-tablet-and-smartohone",
      "transform": "translate(0 -14.128)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12167",
      "data-name": "Path 12167",
      "d": "M8.613,27.536H1.634a.3.3,0,0,1-.294-.3V15.777a.3.3,0,0,1,.294-.3H18.365a.3.3,0,0,1,.294.3v2.51a2.993,2.993,0,0,1,1.34.487v-3a1.644,1.644,0,0,0-1.634-1.649H1.634A1.644,1.644,0,0,0,0,15.777V27.239a1.644,1.644,0,0,0,1.634,1.649H7.242V31.1H6.358a1.014,1.014,0,0,0,0,2.028H9.178a3.059,3.059,0,0,1-.565-1.768V27.536Z",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12168",
      "data-name": "Path 12168",
      "d": "M243.208,156.755v-1.45H240.26v-9.259a.354.354,0,0,1,.354-.354h6.671a.354.354,0,0,1,.354.354v2.865h.5a1.656,1.656,0,0,1,.839.234v-3.1a1.7,1.7,0,0,0-1.7-1.7h-6.671a1.7,1.7,0,0,0-1.7,1.7v9.969a1.7,1.7,0,0,0,1.7,1.7h2.9A1.774,1.774,0,0,1,243.208,156.755Z",
      "transform": "translate(-228.981 -124.642)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12169",
      "data-name": "Path 12169",
      "d": "M365.933,273.775h-3.254a.841.841,0,0,0-.84.84v6.164a.841.841,0,0,0,.84.84h3.254a.841.841,0,0,0,.84-.84v-6.164A.841.841,0,0,0,365.933,273.775Zm-3.088,1.006h2.921v5.328h-2.921Zm1.461,6.43a.361.361,0,1,1,.237-.1A.351.351,0,0,1,364.307,281.211Z",
      "transform": "translate(-346.773 -248.666)",
      "fill": "#575757"
    }
  })])] : _vm.name === 'dialer-microphone-icon' ? [_c('g', {
    attrs: {
      "id": "mic_1_",
      "data-name": "mic (1)",
      "transform": "translate(-95.922)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12569",
      "data-name": "Group 12569",
      "transform": "translate(98.67)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12568",
      "data-name": "Group 12568",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12176",
      "data-name": "Path 12176",
      "d": "M169.809,0a3.506,3.506,0,0,0-3.5,3.5v6.883a3.5,3.5,0,0,0,7,.024V3.5A3.506,3.506,0,0,0,169.809,0Zm2.043,10.408a2.043,2.043,0,0,1-4.085-.024V3.5a2.043,2.043,0,1,1,4.085,0Z",
      "transform": "translate(-166.307)",
      "fill": "#575757"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12571",
      "data-name": "Group 12571",
      "transform": "translate(101.442 15.987)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12570",
      "data-name": "Group 12570"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_3018",
      "data-name": "Rectangle 3018",
      "width": "1.459",
      "height": "3.283",
      "fill": "#575757"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12573",
      "data-name": "Group 12573",
      "transform": "translate(99.521 18.541)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12572",
      "data-name": "Group 12572"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12177",
      "data-name": "Path 12177",
      "d": "M192.679,474.628h-3.842a.73.73,0,0,0,0,1.459h3.842a.73.73,0,1,0,0-1.459Z",
      "transform": "translate(-188.107 -474.628)",
      "fill": "#575757"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12575",
      "data-name": "Group 12575",
      "transform": "translate(95.922 9.175)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12574",
      "data-name": "Group 12574",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12178",
      "data-name": "Path 12178",
      "d": "M107.692,234.822a.73.73,0,0,0-.73.73v.584a4.791,4.791,0,1,1-9.582,0v-.584a.73.73,0,1,0-1.459,0v.584a6.25,6.25,0,0,0,12.5,0v-.584A.73.73,0,0,0,107.692,234.822Z",
      "transform": "translate(-95.922 -234.822)",
      "fill": "#575757"
    }
  })])])])] : _vm.name === 'dialer-voiceMail-icon' ? [_c('g', {
    attrs: {
      "id": "voicemail",
      "transform": "translate(0.25 -138.417)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12578",
      "data-name": "Group 12578",
      "transform": "translate(0 138.667)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12195",
      "data-name": "Path 12195",
      "d": "M18.5,138.667a5.5,5.5,0,0,0-4.245,9H9.74a5.5,5.5,0,1,0-4.24,2h13a5.5,5.5,0,1,0,0-11Zm-13,9a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,5.5,147.667Zm13,0a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,18.5,147.667Z",
      "transform": "translate(0 -138.667)",
      "fill": "#575757",
      "stroke": "#fff",
      "stroke-width": "0.5"
    }
  })])])] : _vm.name === 'dialer-user-icon' ? [_c('g', {
    attrs: {
      "id": "user",
      "transform": "translate(0.155 0.15)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12533",
      "data-name": "Group 12533"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12152",
      "data-name": "Path 12152",
      "d": "M15.955,13.706a.625.625,0,0,0-1.223.255.653.653,0,0,1-.132.547.635.635,0,0,1-.5.238H1.9a.635.635,0,0,1-.5-.238.653.653,0,0,1-.132-.547A6.9,6.9,0,0,1,7.832,8.494q.082,0,.166,0t.166,0a6.873,6.873,0,0,1,5.551,3.051.625.625,0,1,0,1.038-.7,8.127,8.127,0,0,0-4.211-3.2,4.249,4.249,0,1,0-5.086,0A8.127,8.127,0,0,0,.041,13.706,1.9,1.9,0,0,0,1.9,16H14.1a1.9,1.9,0,0,0,1.856-2.289ZM5,4.249a3,3,0,1,1,3.151,3h-.3A3,3,0,0,1,5,4.249Z",
      "transform": "translate(0)",
      "fill": "#5b5b5b",
      "stroke": "#5b5b5b",
      "stroke-width": "0.3"
    }
  })])])] : _vm.name === 'dialer-team-icon' ? [_c('g', {
    attrs: {
      "id": "Group_12681",
      "data-name": "Group 12681",
      "transform": "translate(-17.746 -93.48)"
    }
  }, [_c('g', {
    attrs: {
      "id": "user",
      "transform": "translate(18.001 95.728)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12533",
      "data-name": "Group 12533"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12152",
      "data-name": "Path 12152",
      "d": "M12.967,11.139a.508.508,0,0,0-.994.207.531.531,0,0,1-.108.445.516.516,0,0,1-.406.193H1.541a.516.516,0,0,1-.406-.193.531.531,0,0,1-.108-.445A5.611,5.611,0,0,1,6.366,6.9l.135,0,.135,0a5.586,5.586,0,0,1,4.512,2.48.508.508,0,1,0,.844-.566,6.605,6.605,0,0,0-3.423-2.6,3.453,3.453,0,1,0-4.133,0,6.6,6.6,0,0,0-4.4,4.921A1.543,1.543,0,0,0,1.541,13h9.918a1.543,1.543,0,0,0,1.508-1.861Zm-8.9-7.686A2.438,2.438,0,1,1,6.624,5.888H6.377A2.441,2.441,0,0,1,4.063,3.453Z",
      "transform": "translate(0)",
      "fill": "#5b5b5b",
      "stroke": "#5b5b5b",
      "stroke-width": "0.5"
    }
  })])]), _c('g', {
    attrs: {
      "id": "user-2",
      "data-name": "user",
      "transform": "translate(27.001 93.73)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12533-2",
      "data-name": "Group 12533"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12152-2",
      "data-name": "Path 12152",
      "d": "M14.957,12.849a.586.586,0,0,0-1.147.239.612.612,0,0,1-.124.513.6.6,0,0,1-.469.223H1.778a.6.6,0,0,1-.469-.223.612.612,0,0,1-.124-.513A6.472,6.472,0,0,1,7.343,7.963q.077,0,.155,0t.156,0a6.444,6.444,0,0,1,5.2,2.86.586.586,0,1,0,.973-.652,7.619,7.619,0,0,0-3.948-3,3.983,3.983,0,1,0-4.768,0A7.619,7.619,0,0,0,.038,12.849,1.78,1.78,0,0,0,1.778,15h11.44a1.78,1.78,0,0,0,1.74-2.146ZM4.686,3.983A2.812,2.812,0,1,1,7.64,6.791H7.356A2.815,2.815,0,0,1,4.686,3.983Z",
      "transform": "translate(0)",
      "fill": "#5b5b5b",
      "stroke": "#5b5b5b",
      "stroke-width": "0.5"
    }
  })])])])] : _vm.name === 'dialer-ivr-icon' ? [_c('g', {
    attrs: {
      "id": "IVR",
      "transform": "translate(-4.97 -11.849)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12225",
      "data-name": "Path 12225",
      "d": "M50.324,26H36.916a.667.667,0,1,0,0,1.333H49.647V40.667H29.353V27.333h.609a.667.667,0,1,0,0-1.333H28.676a.672.672,0,0,0-.676.667V49.333a.672.672,0,0,0,.676.667H50.324A.672.672,0,0,0,51,49.333V26.667A.672.672,0,0,0,50.324,26ZM45.588,46V44.667h4.059V46Zm-5.412,0V44.667h1.353V46Zm-2.706,0V44.667h1.353V46Zm-2.706,0V44.667h1.353V46Zm-5.412-1.333h1.353V46H29.353Zm2.706,0h1.353V46H32.059Zm10.824,0h1.353V46H42.882Zm6.765-1.333H48.294V42h1.353Zm-2.706,0H45.588V42h1.353Zm-2.706,0H42.882V42h1.353Zm-2.706,0H40.176V42h1.353Zm-2.706,0H37.471V42h1.353Zm-2.706,0H34.765V42h1.353Zm-2.706,0H32.059V42h1.353Zm-2.706,0H29.353V42h1.353Zm-1.353,4h1.353v1.333H29.353Zm2.706,0h1.353v1.333H32.059Zm2.706,0h9.471v1.333H34.765Zm10.824,0h1.353v1.333H45.588Zm4.059,1.333H48.294V47.333h1.353Z",
      "transform": "translate(-22.98 -14.101)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.1"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12226",
      "data-name": "Path 12226",
      "d": "M43.667,39.668a.667.667,0,0,0,.627-.434l2-5.335a.669.669,0,1,0-1.254-.467L43.667,37.1l-1.374-3.668a.669.669,0,1,0-1.254.467l2,5.335a.667.667,0,0,0,.627.434Z",
      "transform": "translate(-27.147 -16.003)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.1"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12227",
      "data-name": "Path 12227",
      "d": "M53,33H51.667a.667.667,0,0,0-.667.667V39a.667.667,0,0,0,1.334,0V37H53a.667.667,0,0,1,.667.667V39A.667.667,0,1,0,55,39V37.668a2,2,0,0,0-.52-1.334A1.992,1.992,0,0,0,53,33Zm-.667,2.668V34.334H53a.667.667,0,1,1,0,1.334Z",
      "transform": "translate(-30.316 -16.004)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.1"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12228",
      "data-name": "Path 12228",
      "d": "M36.335,34.334a.667.667,0,0,0,0-1.334H33.667a.667.667,0,0,0,0,1.334h.667v4h-.667a.667.667,0,0,0,0,1.334h2.668a.667.667,0,0,0,0-1.334h-.667v-4Z",
      "transform": "translate(-24.646 -16.004)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.1"
    }
  })])] : _vm.name === 'dialer-outlineCirclePause-icon' ? [_c('g', {
    attrs: {
      "id": "Group_12683",
      "data-name": "Group 12683"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12229",
      "data-name": "Path 12229",
      "d": "M11,22A11,11,0,1,0,0,11,11,11,0,0,0,11,22ZM11,1.76A9.24,9.24,0,1,1,1.76,11,9.251,9.251,0,0,1,11,1.76Z",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12230",
      "data-name": "Path 12230",
      "d": "M98.215,80.191a1.106,1.106,0,0,0,1.106-1.106v-8.4a1.106,1.106,0,0,0-2.211,0v8.4A1.106,1.106,0,0,0,98.215,80.191Z",
      "transform": "translate(-89.258 -63.974)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12231",
      "data-name": "Path 12231",
      "d": "M152.606,80.191a1.106,1.106,0,0,0,1.106-1.106v-8.4a1.106,1.106,0,1,0-2.211,0v8.4A1.106,1.106,0,0,0,152.606,80.191Z",
      "transform": "translate(-139.251 -63.974)",
      "fill": "#575757"
    }
  })])] : _vm.name === 'dialer-privacy-icon' ? [_c('g', {
    attrs: {
      "id": "privacy",
      "transform": "translate(-30.9 0.1)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12232",
      "data-name": "Path 12232",
      "d": "M155.1,72.937a4.109,4.109,0,0,0,4.1-4.1v-4.1h-1.173v-1.8a2.931,2.931,0,0,0-5.863,0v1.8H151v4.1A4.109,4.109,0,0,0,155.1,72.937Zm-1.759-10.006a1.759,1.759,0,0,1,3.518,0v1.8h-3.518ZM152.173,65.9h5.863v2.931a2.931,2.931,0,0,1-5.863,0Z",
      "transform": "translate(-115.104 -57.655)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.2"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12233",
      "data-name": "Path 12233",
      "d": "M39.835,19.954,40,20l.165-.046A11.959,11.959,0,0,0,49,8.5V1.172H46.249L45.049,0h-10.1l-1.2,1.172H31V8.5A11.958,11.958,0,0,0,39.835,19.954ZM32.2,2.344h2.049l1.2-1.172h9.1l1.2,1.172H47.8V8.5A10.817,10.817,0,0,1,40,18.78,10.817,10.817,0,0,1,32.2,8.5Z",
      "transform": "translate(0 0)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.2"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_12234",
      "data-name": "Path 12234",
      "d": "M241,241h1.173v3.518H241Z",
      "transform": "translate(-201.586 -231.587)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.2"
    }
  })])] : _vm.name === 'dialer-wallet-icon' ? [_c('g', {
    attrs: {
      "id": "wallet",
      "transform": "translate(0 -19.098)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12235",
      "data-name": "Path 12235",
      "d": "M19.079,23.459h-.261V20.977A1.9,1.9,0,0,0,16.9,19.1H2.966A2.945,2.945,0,0,0,.015,21.715C-.007,21.818,0,20.895,0,35.2a2.937,2.937,0,0,0,2.965,2.9H19.079A1.9,1.9,0,0,0,21,36.219V25.337a1.9,1.9,0,0,0-1.921-1.879ZM2.966,20.388H16.9a.6.6,0,0,1,.6.588v2.482H2.966a1.539,1.539,0,1,1,0-3.07ZM19.079,36.808H2.966A1.63,1.63,0,0,1,1.32,35.2V24.26a3,3,0,0,0,1.646.489H19.079a.6.6,0,0,1,.6.588v2.616H14.716a3,3,0,1,0,0,6H19.68v2.269A.6.6,0,0,1,19.079,36.808Zm.6-4.148H14.716a1.709,1.709,0,1,1,0-3.417H19.68Z",
      "transform": "translate(0)",
      "fill": "#565656"
    }
  }), _c('circle', {
    attrs: {
      "id": "Ellipse_979",
      "data-name": "Ellipse 979",
      "cx": "1.047",
      "cy": "1.047",
      "r": "1.047",
      "transform": "translate(14.87 29.874)",
      "fill": "#565656"
    }
  })])] : _vm.name === 'dialer-globalSetting-icon' ? [_c('g', {
    attrs: {
      "id": "Group_12684",
      "data-name": "Group 12684"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12236",
      "data-name": "Path 12236",
      "d": "M13,0a7.741,7.741,0,0,1,.908.054l.717.084V3.393c.049.01.1.013.148.023l1.506-2.6a.809.809,0,0,1,1.108-.3l4.225,2.437a.813.813,0,0,1,.3,1.11l-1.5,2.6A9.644,9.644,0,0,1,22.191,9.75h3a.813.813,0,0,1,.813.813v4.875a.813.813,0,0,1-.812.813h-3A9.618,9.618,0,0,1,20.4,19.334l1.506,2.6a.813.813,0,0,1-.3,1.11l-4.225,2.438a.819.819,0,0,1-.406.109.807.807,0,0,1-.7-.406l-1.506-2.6c-.047.01-.1.013-.146.023V25.86l-.717.084A7.407,7.407,0,0,1,13,26,13,13,0,0,1,13,0Zm1.625,16.7a4.032,4.032,0,0,0,0-7.407Zm0-9.124a5.649,5.649,0,0,1,0,10.844v2.515c.114-.026.237-.034.349-.063a.819.819,0,0,1,.907.379l1.4,2.418L20.1,22.046,18.7,19.63a.814.814,0,0,1,.125-.977,8,8,0,0,0,1.991-3.437.811.811,0,0,1,.782-.591h2.779v-3.25H21.6a.811.811,0,0,1-.782-.593,8.006,8.006,0,0,0-1.991-3.437A.811.811,0,0,1,18.7,6.37l1.4-2.416L17.279,2.329l-1.4,2.418a.821.821,0,0,1-.907.379c-.112-.029-.236-.037-.349-.062ZM3.794,6.344A24.647,24.647,0,0,0,7.436,7.491a16.638,16.638,0,0,1,3.357-5.647A11.389,11.389,0,0,0,3.794,6.344ZM13,1.924A15.027,15.027,0,0,0,9.067,7.787,25.247,25.247,0,0,0,13,8.125ZM13,9.75a26.725,26.725,0,0,1-4.415-.4,14.662,14.662,0,0,0,0,7.293A26.69,26.69,0,0,1,13,16.25Zm0,14.326v-6.2a26.62,26.62,0,0,0-3.929.343A15.021,15.021,0,0,0,13,24.076Zm-2.207.08a16.681,16.681,0,0,1-3.356-5.642,24.327,24.327,0,0,0-3.643,1.142A11.382,11.382,0,0,0,10.793,24.156ZM6.986,16.949a16.3,16.3,0,0,1,0-7.9,26.19,26.19,0,0,1-4.066-1.3,11.3,11.3,0,0,0,0,10.506A26.079,26.079,0,0,1,6.986,16.949Z",
      "fill": "#575757"
    }
  })])] : _vm.name === 'dialer-locaion-icon' ? [_c('g', {
    attrs: {
      "id": "placeholder",
      "transform": "translate(-63.75 0.25)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12686",
      "data-name": "Group 12686",
      "transform": "translate(64)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12685",
      "data-name": "Group 12685",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12237",
      "data-name": "Path 12237",
      "d": "M71.5,0A7.508,7.508,0,0,0,64,7.5c0,5.2,6.77,12.029,7.058,12.317a.628.628,0,0,0,.885,0C72.23,19.529,79,12.7,79,7.5A7.508,7.508,0,0,0,71.5,0Zm0,18.471c-1.493-1.6-6.25-7-6.25-10.971a6.25,6.25,0,1,1,12.5,0C77.75,11.467,72.993,16.874,71.5,18.471Z",
      "transform": "translate(-64)",
      "fill": "#5b5b5b",
      "stroke": "#5b5b5b",
      "stroke-width": "0.5"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_12688",
      "data-name": "Group 12688",
      "transform": "translate(67.375 3.525)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_12687",
      "data-name": "Group 12687",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_12238",
      "data-name": "Path 12238",
      "d": "M164,96a4,4,0,1,0,4,4A4,4,0,0,0,164,96Zm0,6.667A2.667,2.667,0,1,1,166.667,100,2.669,2.669,0,0,1,164,102.667Z",
      "transform": "translate(-159.875 -95.525)",
      "fill": "#5b5b5b",
      "stroke": "#5b5b5b",
      "stroke-width": "0.5"
    }
  })])])])] : _vm.name === 'dialer-soundLibrary-icon' ? [_c('path', {
    attrs: {
      "id": "musical-note",
      "d": "M74.479,5.221a5.71,5.71,0,0,0-2.2-2.182,6.225,6.225,0,0,1-1.625-1.382l-.075-.1A2.731,2.731,0,0,1,70.015.53.619.619,0,0,0,69.368,0,.612.612,0,0,0,68.8.614V11.581a3.514,3.514,0,0,0-1.832-.5,2.81,2.81,0,0,0-3.054,2.462,3.125,3.125,0,0,0,6.108,0V2.806A8.84,8.84,0,0,0,71.6,4.062a4.71,4.71,0,0,1,1.781,1.7,2.908,2.908,0,0,1,.305,1.413,5.045,5.045,0,0,1-1.07,2.88.616.616,0,0,0,.055.868.605.605,0,0,0,.861-.055,6.309,6.309,0,0,0,1.373-3.616A4.112,4.112,0,0,0,74.479,5.221Z",
      "transform": "translate(-63.913 0)",
      "fill": "#005dff"
    }
  })] : _vm.name === 'dialer-updatesSettings-icon' ? [_c('path', {
    attrs: {
      "id": "Union_126",
      "data-name": "Union 126",
      "d": "M4.489,19.6c-.086-.059-.171-.121-.293-.207.03.1.049.167.065.232a.636.636,0,0,1-.414.777.62.62,0,0,1-.789-.384c-.149-.41-.28-.826-.418-1.24-.151-.454-.3-.909-.453-1.362a.674.674,0,0,1,.119-.748.664.664,0,0,1,.744-.131c.853.289,1.709.568,2.562.856a.635.635,0,0,1-.1,1.244l-.1.02-.024.059c.52.275,1.027.58,1.562.82a9.524,9.524,0,0,0,13.133-6.3,9.132,9.132,0,0,0-.337-5.745c-.036-.092-.078-.182-.105-.276a.635.635,0,0,1,.39-.789.6.6,0,0,1,.8.362,18.052,18.052,0,0,1,.656,2.245A10.765,10.765,0,0,1,14.1,21.146a11.087,11.087,0,0,1-3.326.528A11.023,11.023,0,0,1,4.489,19.6ZM9.6,17.81a.637.637,0,0,1-.67-.681c0-.254-.006-.509,0-.761a.2.2,0,0,0-.153-.233,5.208,5.208,0,0,1-1.534-.877.191.191,0,0,0-.26-.01q-.325.2-.659.381a.625.625,0,0,1-.923-.245q-.626-1.065-1.237-2.14a.625.625,0,0,1,.25-.9c.217-.131.437-.259.66-.379a.2.2,0,0,0,.13-.247,4.532,4.532,0,0,1,0-1.765.188.188,0,0,0-.113-.236c-.23-.121-.455-.254-.678-.39a.624.624,0,0,1-.247-.906Q4.777,7.34,5.4,6.275a.625.625,0,0,1,.923-.24c.222.122.443.247.659.381A.189.189,0,0,0,7.245,6.4,5.177,5.177,0,0,1,8.78,5.526a.2.2,0,0,0,.149-.235c-.007-.246,0-.493,0-.74a.643.643,0,0,1,.694-.7h2.411a.642.642,0,0,1,.7.693c0,.253.005.508,0,.76a.188.188,0,0,0,.143.217,5.725,5.725,0,0,1,1.556.881.264.264,0,0,0,.233.011c.232-.117.452-.26.68-.385a.622.622,0,0,1,.908.24q.628,1.064,1.237,2.14a.626.626,0,0,1-.252.921c-.222.136-.455.255-.672.4a.265.265,0,0,0-.1.212,5.256,5.256,0,0,1,0,1.788.263.263,0,0,0,.1.21c.218.143.45.263.673.4a.627.627,0,0,1,.249.922q-.6,1.066-1.225,2.123a.631.631,0,0,1-.939.244c-.222-.123-.436-.261-.662-.374a.267.267,0,0,0-.233.013,5.79,5.79,0,0,1-1.556.882.187.187,0,0,0-.141.217c.007.261.005.522,0,.783a.634.634,0,0,1-.662.668H10.9ZM7.686,13.962A4.64,4.64,0,0,0,9.661,15.1a.645.645,0,0,1,.535.728v.706h1.269v-.7a.649.649,0,0,1,.554-.733A4.575,4.575,0,0,0,13.943,14a.653.653,0,0,1,.914-.106l.6.346.631-1.1-.629-.365a.644.644,0,0,1-.354-.831,4.1,4.1,0,0,0,0-2.23.64.64,0,0,1,.361-.827l.623-.362-.632-1.094c-.223.128-.435.251-.649.37a.629.629,0,0,1-.844-.106A4.586,4.586,0,0,0,11.991,6.56a.637.637,0,0,1-.525-.692c0-.244,0-.488,0-.741H10.2v.716a.647.647,0,0,1-.543.723A4.591,4.591,0,0,0,7.7,7.691a.633.633,0,0,1-.863.1c-.207-.117-.413-.237-.632-.361-.215.372-.42.729-.632,1.1.231.134.445.256.656.382A.622.622,0,0,1,6.56,9.7a4.186,4.186,0,0,0,0,2.292.616.616,0,0,1-.322.769c-.216.13-.436.255-.667.39l.633,1.1c.225-.13.431-.249.638-.366a.8.8,0,0,1,.392-.121.644.644,0,0,1,.452.2Zm-6.852.915A10.942,10.942,0,0,1,.04,11.713c-.007-.083-.026-.165-.04-.248V10.154c.013-.061.027-.122.037-.184C.123,9.421.176,8.865.3,8.326A10.891,10.891,0,0,1,8.966.165C9.36.1,9.758.055,10.154,0h1.311c.46.067.922.117,1.377.2A10.992,10.992,0,0,1,17.28,2.133c.05.036.1.069.184.125-.028-.1-.049-.165-.065-.231a.639.639,0,0,1,.421-.774.63.63,0,0,1,.788.391c.116.318.215.641.321.961.183.548.364,1.1.547,1.643a.65.65,0,0,1-.875.867q-1.242-.414-2.482-.831a.664.664,0,0,1-.537-.665c.017-.325.23-.532.622-.607a.587.587,0,0,0,.059-.023c-.068-.05-.124-.1-.185-.136A9.491,9.491,0,0,0,10.6,1.279a9.34,9.34,0,0,0-7.465,3.9,9.225,9.225,0,0,0-1.856,5.957,9.322,9.322,0,0,0,.7,3.182.646.646,0,0,1-.262.878.657.657,0,0,1-.3.077.618.618,0,0,1-.583-.4ZM7.658,10.83A3.173,3.173,0,1,1,10.83,14a3.173,3.173,0,0,1-3.172-3.17Zm1.269.006a1.9,1.9,0,1,0,1.909-1.908h0a1.908,1.908,0,0,0-1.909,1.908Z",
      "transform": "translate(0.5 0.5)",
      "fill": "rgb(87, 87, 87)",
      "stroke": "rgba(0,0,0,0)",
      "stroke-miterlimit": "10",
      "stroke-width": "1"
    }
  })] : _vm.name === 'dialer-integrationsSettings-icon' ? [_c('path', {
    attrs: {
      "id": "Union_125",
      "data-name": "Union 125",
      "d": "M0,8.811H2.47c-.074-.211-.143-.4-.207-.593a.879.879,0,1,1,1.686-.1c-.058.225-.145.442-.225.681H6.159v1.309a1.765,1.765,0,0,0,0,3.53v1.335A6.662,6.662,0,0,1,0,8.811ZM7.049,12.5c-.211.074-.4.144-.6.206a.9.9,0,0,1-1.137-.617A.887.887,0,0,1,6.36,11.025c.225.057.442.144.681.224V8.815H8.357a1.779,1.779,0,0,0,.755,1.424,1.69,1.69,0,0,0,1.086.319,1.775,1.775,0,0,0,1.686-1.745c.042,0,.085,0,.128,0H13.15a6.588,6.588,0,0,1-6.1,6.167ZM9.26,8.617c.049-.193.126-.378.189-.567.013-.035.022-.072.036-.122H7.053v-1.3a1.766,1.766,0,1,0,0-3.532V1.8h.823a5.323,5.323,0,0,1,.208-.737A1.718,1.718,0,0,1,9.365.027.172.172,0,0,0,9.414,0h.527A.2.2,0,0,0,9.99.027a1.714,1.714,0,0,1,1.282,1.024,5.27,5.27,0,0,1,.207.737H13.19V3.533a1.742,1.742,0,0,1,1.445.753,4.42,4.42,0,0,1,.337.747v.526a3.7,3.7,0,0,1-.145.422,1.766,1.766,0,0,1-1.567,1.07l-.072.007v.868H10.741c.073.208.141.4.2.589a.876.876,0,0,1-.64,1.151.824.824,0,0,1-.2.024A.882.882,0,0,1,9.26,8.617Zm-4.4-.7a1.766,1.766,0,1,0-3.532,0H.006a6.589,6.589,0,0,1,6.156-6.1V4.234c.211-.074.4-.144.593-.207a.9.9,0,0,1,1.139.614A.889.889,0,0,1,6.866,5.715c-.23-.055-.451-.147-.7-.229V7.922Z",
      "transform": "translate(0.538 0.5)",
      "fill": "rgb(87, 87, 87)",
      "stroke": "rgba(0,0,0,0)",
      "stroke-miterlimit": "10",
      "stroke-width": "1"
    }
  })] : _vm.name === 'settings-callQueue-icon' ? [_c('g', {
    attrs: {
      "id": "Group_15421",
      "data-name": "Group 15421",
      "transform": "translate(8568.737 -3419.763)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Subtraction_10",
      "data-name": "Subtraction 10",
      "d": "M5,15H2.143A2.2,2.2,0,0,1,0,12.75V2.25A2.2,2.2,0,0,1,2.143,0H5V.75H2.143A1.467,1.467,0,0,0,.714,2.25v10.5a1.467,1.467,0,0,0,1.428,1.5H5V15Z",
      "transform": "translate(-8551 3422.697)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41723",
      "data-name": "Path 41723",
      "d": "M-8558.058,3433.5h14.315",
      "transform": "translate(-2.881 -3.304)",
      "fill": "none",
      "stroke": "#575757",
      "stroke-width": "0.75"
    }
  }), _c('g', {
    attrs: {
      "id": "Group_15417",
      "data-name": "Group 15417",
      "transform": "translate(-8559.033 3419.763) rotate(41)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_13097",
      "data-name": "Group 13097"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_29943",
      "data-name": "Path 29943",
      "d": "M0,1.762V1.04A3.969,3.969,0,0,1,.253.472,1.179,1.179,0,0,1,1.04,0h3c.008,0,.016.013.024.015A1.215,1.215,0,0,1,5.095,1.24a7.733,7.733,0,0,0,.1,1.206c.084.491.22.974.335,1.46a1.179,1.179,0,0,1-.224,1.033c-.417.547-.834,1.095-1.246,1.645a.171.171,0,0,0-.015.149,10.341,10.341,0,0,0,1.282,1.9,9.469,9.469,0,0,0,2.723,2.11.182.182,0,0,0,.16-.013c.53-.393,1.062-.782,1.578-1.192a1.237,1.237,0,0,1,1.2-.237,9.212,9.212,0,0,0,2.6.411,1.12,1.12,0,0,1,.964.49,3.184,3.184,0,0,1,.239.547v3a3.946,3.946,0,0,1-.253.567,1.179,1.179,0,0,1-.787.473h-.722c-.047-.007-.094-.016-.141-.022-.535-.06-1.073-.1-1.6-.185A12.93,12.93,0,0,1,7.1,13.129,13.569,13.569,0,0,1,2.079,8.4,13.389,13.389,0,0,1,.087,2.693C.052,2.383.029,2.072,0,1.762",
      "fill": "#575757"
    }
  })])]), _c('g', {
    attrs: {
      "id": "Group_15418",
      "data-name": "Group 15418",
      "transform": "translate(-8547.871 3419.763)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_40273",
      "data-name": "Path 40273",
      "d": "M2.2,12.687h0a2.2,2.2,0,0,1,2.2,2.2v.133a.6.6,0,0,1-.6.6H.6a.6.6,0,0,1-.6-.6v-.133a2.2,2.2,0,0,1,2.2-2.2",
      "transform": "translate(0 -10.03)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_40274",
      "data-name": "Path 40274",
      "d": "M5.757,0A1.257,1.257,0,1,1,4.5,1.257,1.257,1.257,0,0,1,5.757,0",
      "transform": "translate(-3.557)",
      "fill": "#575757"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group_15419",
      "data-name": "Group 15419",
      "transform": "translate(-8547.871 3426.723)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_40273-2",
      "data-name": "Path 40273",
      "d": "M2.2,12.687h0a2.2,2.2,0,0,1,2.2,2.2v.133a.6.6,0,0,1-.6.6H.6a.6.6,0,0,1-.6-.6v-.133a2.2,2.2,0,0,1,2.2-2.2",
      "transform": "translate(0 -10.03)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_40274-2",
      "data-name": "Path 40274",
      "d": "M5.757,0A1.257,1.257,0,1,1,4.5,1.257,1.257,1.257,0,0,1,5.757,0",
      "transform": "translate(-3.557)",
      "fill": "#575757"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group_15420",
      "data-name": "Group 15420",
      "transform": "translate(-8547.871 3433.554)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_40273-3",
      "data-name": "Path 40273",
      "d": "M2.2,12.687h0a2.2,2.2,0,0,1,2.2,2.2v.133a.6.6,0,0,1-.6.6H.6a.6.6,0,0,1-.6-.6v-.133a2.2,2.2,0,0,1,2.2-2.2",
      "transform": "translate(0 -10.03)",
      "fill": "#575757"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_40274-3",
      "data-name": "Path 40274",
      "d": "M5.757,0A1.257,1.257,0,1,1,4.5,1.257,1.257,1.257,0,0,1,5.757,0",
      "transform": "translate(-3.557)",
      "fill": "#575757"
    }
  })])])] : _vm.name === 'settings-callRecording-icon' ? [_c('g', {
    attrs: {
      "id": "Group_15416",
      "data-name": "Group 15416",
      "transform": "translate(8589.737 -3391)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_15414",
      "data-name": "Group 15414",
      "transform": "translate(-8589.737 3392)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_13097",
      "data-name": "Group 13097"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_29943",
      "data-name": "Path 29943",
      "d": "M222.45,562.781v-.951a5.225,5.225,0,0,1,.332-.747,1.552,1.552,0,0,1,1.037-.622h3.956c.011.006.021.017.032.019a1.6,1.6,0,0,1,1.351,1.613,10.184,10.184,0,0,0,.132,1.588c.111.647.29,1.282.441,1.922a1.552,1.552,0,0,1-.295,1.36c-.549.721-1.1,1.441-1.64,2.167a.225.225,0,0,0-.02.2,13.614,13.614,0,0,0,1.688,2.5,12.467,12.467,0,0,0,3.585,2.778.24.24,0,0,0,.211-.017c.7-.517,1.4-1.029,2.078-1.569a1.629,1.629,0,0,1,1.584-.311,12.13,12.13,0,0,0,3.421.541,1.474,1.474,0,0,1,1.269.645,4.192,4.192,0,0,1,.314.721v3.956a5.2,5.2,0,0,1-.333.747,1.553,1.553,0,0,1-1.037.622H239.6c-.062-.01-.124-.021-.186-.029-.7-.08-1.413-.13-2.112-.243a17.023,17.023,0,0,1-5.512-1.917,17.866,17.866,0,0,1-6.607-6.226,17.629,17.629,0,0,1-2.623-7.515c-.046-.408-.076-.817-.114-1.226",
      "transform": "translate(-222.45 -560.461)",
      "fill": "#575757"
    }
  })])]), _c('path', {
    attrs: {
      "id": "Subtraction_9",
      "data-name": "Subtraction 9",
      "d": "M15,8H2A1,1,0,0,1,1,7V1A1,1,0,0,1,2,0H15a1,1,0,0,1,1,1V7A1,1,0,0,1,15,8ZM11.983,2.672A1.376,1.376,0,0,0,10.566,4.1a1.374,1.374,0,0,0,1.417,1.424,1.305,1.305,0,0,0,1.311-.9H12.65a.7.7,0,0,1-.672.4.836.836,0,0,1-.836-.924.836.836,0,0,1,.836-.924.7.7,0,0,1,.672.4h.644A1.308,1.308,0,0,0,11.983,2.672ZM8.574,2.7V5.5h1.62V5.044H9.134V4.3h.94V3.86h-.94v-.7h1.06V2.7Zm-2,1.708h.265L7.45,5.5H8.1L7.43,4.369a.8.8,0,0,0,.635-.8c0-.52-.4-.856-1.008-.856H6.01V5.5h.56V4.414ZM3.7,3.343a.675.675,0,1,0,.675.675A.676.676,0,0,0,3.7,3.343Zm3.335.65H6.57v-.82h.468c.3,0,.452.14.452.4S7.334,3.992,7.038,3.992Z",
      "transform": "translate(-8580 3391)",
      "fill": "#575757"
    }
  })])] : _vm.name === 'settings-supportTicket-icon' ? [_c('g', {
    attrs: {
      "id": "Group_15427",
      "data-name": "Group 15427",
      "transform": "translate(8599.811 -3421.115)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group_15426",
      "data-name": "Group 15426"
    }
  }, [_c('path', {
    attrs: {
      "id": "Path_41724",
      "data-name": "Path 41724",
      "d": "M26.777,76c-.034.068-.069.135-.1.2a1.088,1.088,0,0,1-.887.647,3.335,3.335,0,0,1-.391.018q-12.012,0-24.023,0a2.315,2.315,0,0,1-.545-.047A1.11,1.11,0,0,1,0,75.733C0,75.165,0,74.6,0,74.03q0-4.283,0-8.566A1.284,1.284,0,0,1,.011,65.2a.367.367,0,0,1,.382-.325.365.365,0,0,1,.384.322,1.393,1.393,0,0,1,.009.287q0,5.03,0,10.059c0,.439.087.533.511.533q3.908,0,7.816,0c.077,0,.153-.009.253-.015,0-.267,0-.518,0-.769,0-.29.147-.459.384-.464s.4.164.4.471c0,.244,0,.488,0,.761.1.006.2.015.288.015h15c.466,0,.548-.083.549-.548,0-.026,0-.052,0-.079-.011-.221.017-.423.259-.516s.389.058.526.223Z",
      "transform": "translate(-8599.687 3360.894)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41725",
      "data-name": "Path 41725",
      "d": "M333.92,13.4c-.121.191-.276.329-.516.246s-.271-.284-.27-.51q0-5.9,0-11.8c0-.457-.076-.533-.53-.533h-1.776a2.1,2.1,0,0,1-.235-.007.392.392,0,0,1-.386-.409.381.381,0,0,1,.4-.366c.235-.01.47,0,.7,0,.383,0,.768.023,1.149-.005a1.292,1.292,0,0,1,1.459.866Z",
      "transform": "translate(-8906.828 3421.24)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41726",
      "data-name": "Path 41726",
      "d": "M189.1,50.193a2.628,2.628,0,0,1,.417-.662,1.358,1.358,0,0,0,.516-1.248.958.958,0,0,0-.342-.789,1.987,1.987,0,0,1-.259-.258.879.879,0,0,1-.15-1.041,8.773,8.773,0,0,1,.456-.792.866.866,0,0,1,.923-.4.383.383,0,0,1,.128.024c.655.374,1.153-.02,1.661-.345a.4.4,0,0,0,.128-.213c.063-.2.1-.4.165-.605a.907.907,0,0,1,.906-.688c.27,0,.54-.006.81,0a.888.888,0,0,1,.849.618.42.42,0,0,1,.038.124c.018.752.608.984,1.144,1.26a.36.36,0,0,0,.222,0c.229-.052.453-.126.683-.171a.858.858,0,0,1,.947.4c.161.248.31.506.446.768a.894.894,0,0,1-.145,1.065.18.18,0,0,1-.036.038c-.657.388-.57,1.026-.542,1.64a.359.359,0,0,0,.1.2c.135.148.284.283.423.428a.914.914,0,0,1,.158,1.192c-.117.214-.239.426-.366.634a.842.842,0,0,1-1.065.435,1.474,1.474,0,0,0-1.52.234.73.73,0,0,0-.349.48c-.182.875-.384,1.207-1.467,1.146-.1-.006-.209,0-.313,0a.845.845,0,0,1-.915-.7,1.472,1.472,0,0,0-.958-1.206.767.767,0,0,0-.586-.068c-1.029.3-1.212.219-1.741-.714-.134-.237-.235-.616-.37-.906m1.7-1.655a1.507,1.507,0,0,1-.48,1.416c-.49.437-.444.268-.11.862.253.448.168.441.653.271a1.47,1.47,0,0,1,1.452.193,5.89,5.89,0,0,1,.555.339,2.33,2.33,0,0,1,.432.564,1.314,1.314,0,0,1,.132.476c.035.267.159.354.433.346.68-.021.688,0,.851-.676a1.141,1.141,0,0,1,.612-.8c.263-.135.514-.294.771-.441a.894.894,0,0,1,.728-.1c.166.05.343.073.5.138.235.1.356.019.474-.2.332-.61.348-.611-.156-1.1a1.107,1.107,0,0,1-.378-.906,6.961,6.961,0,0,0,0-.785,1.107,1.107,0,0,1,.377-.906c.5-.487.486-.487.158-1.1-.128-.238-.267-.286-.5-.187a1.488,1.488,0,0,1-1.615-.2.476.476,0,0,0-.113-.066,1.493,1.493,0,0,1-.939-1.218c-.079-.439-.035-.391-.487-.391-.632,0-.647,0-.787.617a1.205,1.205,0,0,1-.669.877c-.249.124-.483.277-.726.414a.9.9,0,0,1-.728.1c-.166-.05-.343-.073-.5-.138-.235-.1-.356-.02-.474.2-.332.61-.348.611.156,1.1a1.091,1.091,0,0,1,.377.906c-.01.13,0,.262,0,.393",
      "transform": "translate(-8775.578 3381.085)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41727",
      "data-name": "Path 41727",
      "d": "M10.159.944c0,.293,0,.544,0,.8,0,.287-.154.451-.4.446a.393.393,0,0,1-.384-.438c-.006-.259,0-.519,0-.8H1.351C.86.944.795,1.01.795,1.5c0,.585,0,1.17,0,1.755,0,.315-.136.486-.381.492s-.4-.17-.4-.5c0-.646,0-1.292,0-1.939A1.114,1.114,0,0,1,1.139.159c.078,0,.157,0,.235,0h20.1c.1,0,.192,0,.287,0a.364.364,0,0,1,.368.367.371.371,0,0,1-.358.4,2.384,2.384,0,0,1-.313.01h-11.3",
      "transform": "translate(-8599.693 3421.094)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41728",
      "data-name": "Path 41728",
      "d": "M31.851,26.424q1.228,0,2.455,0c.436,0,.55.109.551.535q0,1.112,0,2.225c0,.422-.12.54-.552.54q-2.455,0-4.911,0c-.431,0-.549-.117-.55-.541q0-1.112,0-2.225c0-.418.115-.533.525-.534.827,0,1.654,0,2.481,0m2.221.811h-4.42v1.7h4.172c.118,0,.252.031.25-.167-.005-.5,0-1.01,0-1.537",
      "transform": "translate(-8626.514 3396.662)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41729",
      "data-name": "Path 41729",
      "d": "M31.972,100.7H34.4a1.351,1.351,0,0,1,.26.015.384.384,0,0,1,.027.741,1.326,1.326,0,0,1-.336.028q-2.389,0-4.777,0c-.428,0-.611-.119-.612-.395s.175-.391.61-.391h2.4",
      "transform": "translate(-8626.624 3327.571)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41730",
      "data-name": "Path 41730",
      "d": "M31.956,125.692c.836,0,1.671,0,2.507,0,.327,0,.5.146.495.4s-.183.382-.493.382q-2.507,0-5.013,0c-.321,0-.5-.152-.494-.407s.175-.378.492-.378c.836,0,1.671,0,2.507,0",
      "transform": "translate(-8626.62 3304.329)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41731",
      "data-name": "Path 41731",
      "d": "M31.955,151.424c-.836,0-1.671,0-2.507,0-.327,0-.5-.146-.5-.4s.181-.383.491-.383q2.507,0,5.013,0c.323,0,.5.151.5.4s-.174.379-.491.38c-.836,0-1.671,0-2.507,0",
      "transform": "translate(-8626.616 3281.125)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41732",
      "data-name": "Path 41732",
      "d": "M32.038,176.516c-.8,0-1.6,0-2.4,0-.112,0-.257.021-.329-.037a.72.72,0,0,1-.255-.375.31.31,0,0,1,.276-.354,1.326,1.326,0,0,1,.286-.018H34.47a1.445,1.445,0,0,1,.26.013.384.384,0,0,1,.021.747,1.4,1.4,0,0,1-.311.024q-1.2,0-2.4,0",
      "transform": "translate(-8626.703 3257.784)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41733",
      "data-name": "Path 41733",
      "d": "M134.834,84.036c0,.209.006.418,0,.626a.388.388,0,1,1-.776.01c-.012-.417-.012-.835,0-1.253a.383.383,0,0,1,.4-.395.388.388,0,0,1,.38.411c.007.2,0,.4,0,.6",
      "transform": "translate(-8724.369 3344.015)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41734",
      "data-name": "Path 41734",
      "d": "M134.84,125.425c0,.209.007.418,0,.626a.382.382,0,0,1-.378.385.376.376,0,0,1-.4-.369c-.014-.435-.014-.87,0-1.3a.383.383,0,0,1,.4-.362.389.389,0,0,1,.369.4c.009.208,0,.418,0,.626",
      "transform": "translate(-8724.375 3305.528)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41735",
      "data-name": "Path 41735",
      "d": "M134.837,42.679c0,.2.006.4,0,.6a.389.389,0,1,1-.778,0q-.015-.613,0-1.226a.39.39,0,1,1,.78,0c0,.017,0,.035,0,.052q0,.287,0,.574",
      "transform": "translate(-8724.371 3382.496)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41736",
      "data-name": "Path 41736",
      "d": "M134.077,166.855c0-.2-.008-.4,0-.6a.4.4,0,0,1,.394-.4.385.385,0,0,1,.384.407q.011.613,0,1.226a.373.373,0,0,1-.363.4.379.379,0,0,1-.413-.376c-.014-.216,0-.435,0-.652h0",
      "transform": "translate(-8724.395 3266.972)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  }), _c('path', {
    attrs: {
      "id": "Path_41737",
      "data-name": "Path 41737",
      "d": "M230.466,86.646a2.21,2.21,0,1,1-2.23,2.185,2.2,2.2,0,0,1,2.23-2.185m-.026.786a1.424,1.424,0,1,0,1.422,1.429,1.41,1.41,0,0,0-1.422-1.429",
      "transform": "translate(-8811.979 3340.646)",
      "fill": "#575757",
      "stroke": "#575757",
      "stroke-width": "0.25"
    }
  })])])] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }